// Mutation: Asignar permisos a un grupo
export const assignPermissionsToGroup = ({ groupId, permissionIds }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($groupId: ID!, $permissionIds: [ID]!) {
            assignPermissionsToGroup(groupId: $groupId, permissionIds: $permissionIds) {
                group {
                    id
                    name
                    permission {
                        id
                        name
                        description
                    }
                }
                error
            }
        }`,
        variables: { groupId, permissionIds }
    });
};

// Mutation: Sincronizar permisos y roles
export const syncPermissionsAndRoles = ({ syncPermissions = true, syncRoles = true, forceRoles = false }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($syncPermissions: Boolean, $syncRoles: Boolean, $forceRoles: Boolean) {
            syncPermissionsAndRoles(
                syncPermissions: $syncPermissions,
                syncRoles: $syncRoles,
                forceRoles: $forceRoles
            ) {
                success
                message
                permissionsCreated
                permissionsUpdated
                permissionsSkipped
                rolesCreated
                rolesUpdated
                error
            }
        }`,
        variables: { syncPermissions, syncRoles, forceRoles }
    });
};
// --- LOADING Y FEEDBACK GLOBAL ---
import Swal from "sweetalert2";
// Spinner global
let spinnerDiv = null;
let activeRequests = 0;

// Función mejorada para mostrar el loading
export const showLoading = (text = "Cargando...") => {
    if (activeRequests === 0) {
        if (!spinnerDiv) {
            spinnerDiv = document.createElement("div");
            spinnerDiv.id = "global-spinner";
            spinnerDiv.innerHTML = `
                <div style="position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9999;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;">
                    <div style="display:flex;flex-direction:column;align-items:center;">
                        <div class="site-spinner" style="width:64px;height:64px;border:8px solid #3A9F1D;border-top:8px solid #e0e0e0;border-radius:50%;animation:spin 1s linear infinite;"></div>
                        <p style="color:white;margin-top:10px;">${text}</p>
                    </div>
                </div>
                <style>
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                </style>
            `;
            document.body.appendChild(spinnerDiv);
        } else {
            spinnerDiv.style.display = 'flex';
        }
    }
    activeRequests++;
};

// Función mejorada para ocultar el loading
export const hideLoading = () => {
    activeRequests = Math.max(0, activeRequests - 1);
    if (activeRequests === 0 && spinnerDiv) {
        // Agregar transición suave
        spinnerDiv.style.transition = 'opacity 0.3s';
        spinnerDiv.style.opacity = '0';
        
        // Esperar a que termine la transición antes de remover
        setTimeout(() => {
            if (spinnerDiv && activeRequests === 0) {
                document.body.removeChild(spinnerDiv);
                spinnerDiv = null;
            }
        }, 300);
    }
};

export const showSuccess = (msg = "Operación exitosa", title = "Éxito", options = {}) => {
    Swal.fire({ 
        icon: "success", 
        title, 
        text: msg, 
        timer: 1800, 
        showConfirmButton: false,
        customClass: {
            container: 'swal2-high-z-index'
        },
        ...options 
    });
};
export const showError = (msg = "Ocurrió un error", title = "Error", options = {}) => {
    Swal.fire({ 
        icon: "error", 
        title, 
        text: msg,
        customClass: {
            container: 'swal2-high-z-index'
        },
        ...options 
    });
};
// --- LOGOUT ---
export const logout = () => {
    sessionStorage.removeItem("token");
    // Si usas Vuex, puedes limpiar el estado aquí si lo necesitas
    // Ejemplo: store.commit('doLogout');
};
// --- AUTENTICACIÓN ---
export const login = ({ username, password }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($username: String!, $password: String!) {
            login(username: $username, password: $password) {
                token
                user {
                    id
                    username
                    firstName
                    lastName
                    email
                }
                error
            }
        }`,
        variables: { username, password }
    });
};

export const me = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            me {
                id
                username
                firstName
                lastName
                email
                phone
                codePhone
                firma
                groups {
                    id
                    name
                }
            }
        }`
    });
};

// --- PERMISOS Y ROLES ---
export const getUserPermissions = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            myPermissions
            myRole
        }`
    });
};

export const checkPermission = (permission) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($permission: String!) {
            hasPermission(permission: $permission)
        }`,
        variables: { permission }
    });
};

export const checkCanDelete = (module) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($module: String!) {
            canDelete(module: $module)
        }`,
        variables: { module }
    });
};

// --- USUARIOS ---
export const allUsers = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allUsers {
                id
                firstName
                lastName
                email
                username
                isActive
            }
        }`
    });
};

export const createUser = (obj) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation(
                     $email: String!,
                     $password: String!,
                     $phone: String!,
                     $codePhone: String!,
                     $groupId: ID,
                     $firstName:String!,
                     $lastName:String!) {
            createUser(
                    firstName: $firstName,
                    lastName: $lastName,
                    email: $email,
                    password: $password,
                    phone: $phone,
                    codePhone: $codePhone,
                    groupId: $groupId
                ) {
                user {
                    id
                    firstName
                    lastName
                    email
                }
                error
            }
        }`,
        variables: obj
    });
};

export const updateUser = (obj) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation(
                $id: ID!,
                $firstName:String!,
                $lastName:String!
                $email: String!,
                $phone: String!,
                $codePhone: String!,
                $groupId: ID!
        ) {
            updateUser(
                id: $id,
                firstName: $firstName,
                lastName: $lastName,
                email: $email,
                phone: $phone,
                codePhone: $codePhone,
                groupId: $groupId
            ) {
                user {
                    id
                    username
                    firstName
                    lastName
                    email
                }
                error
            }
        }`,
        variables: obj
    });
};

export const setUserBranch = (id, branchId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $branchId: ID!) {
            updateUser(id: $id, branchId: $branchId) {
                user {
                    id
                    branch {
                        id
                        name
                    }
                }
                error
            }
        }`,
        variables: { id, branchId }
    });
};

export const deleteUser = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteUser(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};

export const users = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            users {
                id
                firstName
                lastName
                email
                phone
                isDelete
                groups {
                    id
                    name
                }
                branch {
                    id
                    name
                }
            }
        }`
    });
};

export const user = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            user(id: $id) {
                id
                firstName
                lastName
                email
                phone
                group {
                    id
                    name
                }
            }
        }`,
        variables: { id }
    });
};

// --- PERFIL (no modifica correo, teléfono ni contraseña; solo nombre y apellidos) ---
export const updateProfile = ({ firstName, lastName }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($firstName: String, $lastName: String) {
            updateProfile(firstName: $firstName, lastName: $lastName) {
                user {
                    id
                    firstName
                    lastName
                    email
                }
                error
            }
        }`,
        variables: {
            firstName: firstName ?? null,
            lastName: lastName ?? null
        }
    });
};

export const changePassword = ({ currentPassword, newPassword }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($currentPassword: String!, $newPassword: String!) {
            changePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
                success
                error
            }
        }`,
        variables: { currentPassword, newPassword }
    });
};

// --- GRUPOS ---
export const createGroup = ({ name, permissionIds }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($name: String!) {
            createGroup(name: $name) {
                group {
                    id
                    name
                }
                error
            }
        }`,
        variables: { name }
    });
};

export const updateGroup = ({ id, name }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $name: String) {
            updateGroup(id: $id, name: $name) {
                group {
                    id
                    name
                }
                error
            }
        }`,
        variables: { id, name }
    });
};

export const deleteGroup = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteGroup(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};

export const groups = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            groups {
                id
                name
                permission {
                    id
                    name
                    description
                }
            }
        }`
    });
};

export const group = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            group(id: $id) {
                id
                name
            }
        }`,
        variables: { id }
    });
};

// --- PERMISOS ---
export const createPermission = ({ name, description }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($name: String!, $description: String) {
            createPermission(name: $name, description: $description) {
                permission {
                    id
                    name
                    description
                }
                error
            }
        }`,
        variables: { name, description }
    });
};

export const permissions = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query Permissions {
                    permissions {
                        id
                        name
                        description
                    }
                }`
    });
};
export const updatePermission = ({ id, name, description }) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $name: String, $description: String) {
            updatePermission(id: $id, name: $name, description: $description) {
                permission {
                    id
                    name
                    description
                }
                error
            }
        }`,
        variables: { id, name, description }
    });
};
export const deletePermission = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation DeletePermission($id:ID!) {
                    deletePermission(id: $id) {
                        ok
                        error
                    }
                }`,
        variables: { id }
    });
};

//logs
export const logs = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query Traces {
                    traces {
                        id
                        action
                        date
                        module
                        user {
                            email
                        }
                    }
                }`
    });
};

import axios from "axios";

// Configuración base de Axios
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.timeout = 30000; // 30 segundos

// Función para obtener el token JWT (exportada para uso en PDF y otras vistas)
export const getToken = () => {
    try {
        // Primero intentar localStorage (persiste entre actualizaciones)
        let authDataStr = localStorage.getItem("authData");
        
        // Si no está en localStorage, intentar sessionStorage
        if (!authDataStr) {
            authDataStr = sessionStorage.getItem("authData");
        }
        
        if (authDataStr) {
            const authData = JSON.parse(authDataStr);
            return authData.token;
        }
        
        // Fallback para compatibilidad
        return sessionStorage.getItem("token") || localStorage.getItem("token");
    } catch (error) {
        return null;
    }
};

// Interceptor para agregar el token JWT y mostrar loading en cada petición
axios.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        // No mostrar loading para peticiones específicas que no lo necesitan
        if (!config.headers["X-No-Loading"]) {
            showLoading(config.loadingText || "Cargando...");
        }
        return config;
    },
    error => {
        if (!error.config?.headers?.["X-No-Loading"]) {
            hideLoading();
        }
        return Promise.reject(error);
    }
);

// Manejo global de loading y feedback (éxito/error)
axios.interceptors.response.use(
    response => {
        if (!response.config?.headers?.["X-No-Loading"]) {
            // Usar setTimeout para asegurar que se ejecute en el siguiente ciclo de eventos
            setTimeout(hideLoading, 100);
        }
        
        // Si la respuesta tiene error GraphQL y no hay datos de éxito, mostrarlo
        // (si viene data y errors juntos, la operación pudo haber tenido éxito y el componente lo maneja)
        if (response.data && response.data.errors && response.data.errors.length && !response.data.data) {
            const errorMessage = response.data.errors[0]?.message || 'Error en la petición';
            if (errorMessage !== 'No autenticado.') {
                showError(errorMessage);
            }
        }
        return response;
    },
    error => {
        if (!error.config?.headers?.["X-No-Loading"]) {
            hideLoading();
        }
        
        // Si es una cancelación de petición, no mostrar error
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }
        
        if (error.response) {
            if (error.response.status === 401) {
                // Limpiar datos de autenticación de ambos storages
                sessionStorage.removeItem("authData");
                sessionStorage.removeItem("token");
                localStorage.removeItem("authData");
                localStorage.removeItem("token");
                localStorage.removeItem("isAuth");
                
                // Solo redirigir si no estamos ya en login y no es una petición de login
                if (window.location.pathname !== "/login" && !error.config?.url?.includes("login")) {
                    window.location.href = "/login";
                }
            } else if (error.response.status >= 500) {
                showError("Error del servidor. Por favor, intente nuevamente más tarde.");
            } else if (error.response.data && error.response.data.message) {
                showError(error.response.data.message);
            } else {
                showError(`Error ${error.response.status}: ${error.response.statusText}`);
            }
        } else if (error.request) {
            showError("No se pudo conectar al servidor. Verifique su conexión a Internet.");
        } else {
            showError(error.message || "Ocurrió un error inesperado");
        }
        
        return Promise.reject(error);
    }
);

// Recargar encabezados manualmente si es necesario
export const reloadHeader = () => {
    axios.defaults.headers.post["Authorization"] = `Bearer ${getToken()}`;
};


// Query: Obtener notificaciones
export const getNotifications = (next = "") => {
    return axios.post(
        process.env.VUE_APP_URL_SERVICES_GRAPHQL,
        {
            query: `{
                searchFirebaseNotifications(first: 10, after: "${next}", messageIcontains: "", firebase: false){
                    pageInfo{
                        endCursor
                        hasNextPage
                    }
                    edges{
                        node{
                            id
                            message
                            readClient
                            title
                            reservation {
                                id
                                total
                                email
                                tipoCobertura
                                dias
                                serviciosExtras
                                tarifaDiaria
                                comentarios
                                fechaRenta
                                fechaFin
                                nombre
                                apellidos
                                telefono
                                edad
                                pagoId
                                origen
                                revisado
                                noReserva
                                fecha
                                estado
                                metodoPago
                                cantidad
                                categoria {
                                    id
                                    name
                                    tradicionalAlta
                                    totalAlta
                                    tradicionalBaja
                                    totalBaja
                                    isActive
                                    fecha
                                    image
                                    iconoWhite
                                    iconoBlack
                                    maletas
                                    maletasSm
                                    personas
                                    transmision
                                    lugar
                                }
                                sucursal {
                                    id
                                    name
                                    phone
                                    contactPhone
                                    address
                                    postalCod
                                    openHour
                                    closeHour
                                    isActive
                                }
                                agente {
                                    id
                                    username
                                    firstName
                                    lastName
                                    email
                                    isActive
                                    phone
                                }
                            }
                        }
                    }
                }
            }`
        }
    );
};

// --- CLIENTES ---
export const clients = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            clients {
                id
                firstName
                lastName
                curp
                rfc
                birthDate
                gender
                maritalStatus
                mainPhone
                mainCodePhone
                secondaryPhone
                secondaryCodePhone
                email
                address
                ine
                createdBy {
                    email
                }
            }
        }`
    });
};

// Query específica para el selector de clientes (solo datos básicos)
export const clientsForSelector = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            clients {
                id
                firstName
                lastName
                mainPhone
                email
                ineFoto
                licenciaFoto
                comprobanteDomicilio
                comprobanteIngresos
            }
        }`
    });
};
export const client = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            client(id: $id) {
                id
                firstName
                lastName
                curp
                rfc
                birthDate
                gender
                maritalStatus
                mainPhone
                secondaryPhone
                email
                address
                ine
                createdById
            }
        }`,
        variables: { id }
    });
};

export const clientById = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: Int!) {
            client(id: $id) {
                id
                firstName
                lastName
                curp
                rfc
                birthDate
                gender
                maritalStatus
                mainPhone
                mainCodePhone
                secondaryPhone
                secondaryCodePhone
                email
                address
                ine
                ineFoto
                licenciaFoto
                comprobanteDomicilio
                comprobanteIngresos
            }
        }`,
        variables: { id: parseInt(id) }
    });
};
export const createClient = (clientData) => {
    const variables = {
        firstName: clientData.firstName,
        lastName: clientData.lastName,
        curp: clientData.curp || null,
        rfc: clientData.rfc || null,
        birthDate: clientData.birthDate || null,
        gender: clientData.gender || null,
        maritalStatus: clientData.maritalStatus || null,
        mainPhone: clientData.mainPhone,
        mainCodePhone: clientData.mainCodePhone ?? null,
        secondaryPhone: clientData.secondaryPhone || null,
        secondaryCodePhone: clientData.secondaryCodePhone ?? null,
        email: clientData.email || null,
        address: clientData.address || null,
        ine: clientData.ine || clientData.mainPhone,
        createdById: clientData.createdById || "1"
    };

    const fileFields = [
        { snake: 'ine_foto', camel: 'ineFoto' },
        { snake: 'licencia_foto', camel: 'licenciaFoto' },
        { snake: 'comprobante_domicilio', camel: 'comprobanteDomicilio' },
        { snake: 'comprobante_ingresos', camel: 'comprobanteIngresos' }
    ];

    const hasFiles = fileFields.some(field => {
        const file = clientData[field.snake] || clientData[field.camel];
        return typeof File !== 'undefined' && file instanceof File;
    });

    if (hasFiles) {
        const formData = new FormData();
        const uploadVariables = { ...variables };
        const fileVariables = [];

        fileFields.forEach(field => {
            const file = clientData[field.snake] || clientData[field.camel];
            if (typeof File !== 'undefined' && file instanceof File) {
                fileVariables.push(field.camel);
                uploadVariables[field.camel] = null;
            }
        });

        const query = `mutation($firstName: String!, $lastName: String!, $curp: String, $rfc: String, $birthDate: Date, $gender: String, $maritalStatus: String, $mainPhone: String!, $mainCodePhone: String, $secondaryPhone: String, $secondaryCodePhone: String, $email: String, $address: String, $ine: String!, $createdById: ID!${fileVariables.map(f => `, $${f}: Upload`).join('')}) {
            createClient(
                firstName: $firstName,
                lastName: $lastName,
                curp: $curp,
                rfc: $rfc,
                birthDate: $birthDate,
                gender: $gender,
                maritalStatus: $maritalStatus,
                mainPhone: $mainPhone,
                mainCodePhone: $mainCodePhone,
                secondaryPhone: $secondaryPhone,
                secondaryCodePhone: $secondaryCodePhone,
                email: $email,
                address: $address,
                ine: $ine,
                createdById: $createdById${fileVariables.map(f => `, ${f}: $${f}`).join('')}
            ) {
                client {
                    id
                    firstName
                    lastName
                    curp
                    rfc
                    mainPhone
                    mainCodePhone
                    secondaryPhone
                    secondaryCodePhone
                    email
                    address
                    ine
                }
                error
            }
        }`;

        formData.append('operations', JSON.stringify({ query, variables: uploadVariables }));

        const fileMapObj = {};
        let fileIndex = 0;
        fileFields.forEach(field => {
            const file = clientData[field.snake] || clientData[field.camel];
            if (typeof File !== 'undefined' && file instanceof File) {
                fileMapObj[fileIndex.toString()] = [`variables.${field.camel}`];
                formData.append(fileIndex.toString(), file);
                fileIndex++;
            }
        });

        formData.append('map', JSON.stringify(fileMapObj));

        return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($firstName: String!, $lastName: String!, $curp: String, $rfc: String, $birthDate: Date, $gender: String, $maritalStatus: String, $mainPhone: String!, $mainCodePhone: String, $secondaryPhone: String, $secondaryCodePhone: String, $email: String, $address: String, $ine: String!, $createdById: ID!) {
            createClient(
                firstName: $firstName,
                lastName: $lastName,
                curp: $curp,
                rfc: $rfc,
                birthDate: $birthDate,
                gender: $gender,
                maritalStatus: $maritalStatus,
                mainPhone: $mainPhone,
                mainCodePhone: $mainCodePhone,
                secondaryPhone: $secondaryPhone,
                secondaryCodePhone: $secondaryCodePhone,
                email: $email,
                address: $address,
                ine: $ine,
                createdById: $createdById
            ) {
                client {
                    id
                    firstName
                    lastName
                    curp
                    rfc
                    mainPhone
                    mainCodePhone
                    secondaryPhone
                    secondaryCodePhone
                    email
                    address
                    ine
                }
                error
            }
        }`,
        variables
    });
};
export const updateClient = (id, input) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: Int!, $firstName: String, $lastName: String, $curp: String, $rfc: String, $birthDate: Date, $gender: String, $maritalStatus: String, $mainPhone: String, $mainCodePhone: String, $secondaryPhone: String, $secondaryCodePhone: String, $email: String, $address: String, $ine: String, $updatedById: Int, $ineFoto: String, $licenciaFoto: String, $comprobanteDomicilio: String, $comprobanteIngresos: String) {
            updateClient(id: $id, firstName: $firstName, lastName: $lastName, curp: $curp, rfc: $rfc, birthDate: $birthDate, gender: $gender, maritalStatus: $maritalStatus, mainPhone: $mainPhone, mainCodePhone: $mainCodePhone, secondaryPhone: $secondaryPhone, secondaryCodePhone: $secondaryCodePhone, email: $email, address: $address, ine: $ine, updatedById: $updatedById, ineFoto: $ineFoto, licenciaFoto: $licenciaFoto, comprobanteDomicilio: $comprobanteDomicilio, comprobanteIngresos: $comprobanteIngresos) {
                client {
                    id
                    firstName
                    lastName
                    curp
                    rfc
                    birthDate
                    gender
                    maritalStatus
                    mainPhone
                    mainCodePhone
                    secondaryPhone
                    secondaryCodePhone
                    email
                    address
                    ine
                }
                error
            }
        }`,
        variables: (() => {
            const base = {
                id: parseInt(id),
                firstName: input.firstName,
                lastName: input.lastName,
                curp: input.curp,
                birthDate: input.birthDate,
                gender: input.gender,
                maritalStatus: input.maritalStatus,
                mainPhone: input.mainPhone ?? null,
                secondaryPhone: input.secondaryPhone ?? null,
                email: input.email,
                address: input.address,
                ine: input.ine,
                updatedById: 1,
                ineFoto: input.ine_foto || input.ineFoto || null,
                licenciaFoto: input.licencia_foto || input.licenciaFoto || null,
                comprobanteDomicilio: input.comprobante_domicilio || input.comprobanteDomicilio || null,
                comprobanteIngresos: input.comprobante_ingresos || input.comprobanteIngresos || null
            };
            // Solo enviar rfc/mainCodePhone/secondaryCodePhone si están definidos (evitar sobrescribir con null en BD)
            if (input.rfc !== undefined) base.rfc = input.rfc;
            if (input.mainCodePhone !== undefined) base.mainCodePhone = input.mainCodePhone;
            if (input.secondaryCodePhone !== undefined) base.secondaryCodePhone = input.secondaryCodePhone;
            return base;
        })()
    });
};
export const deleteClient = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteClient(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};

// --- AUTOS ---
// availableForQuote: si es true, solo devuelve vehículos que NO están en contratos activos (para cotización/contrato)
const CAR_DOCUMENTATION_URL_FIELDS = `
                tipoVehiculo
                tarjetaCirculacionUrl
                tarjetaCirculacionDigitalUrl
                licenciaConductorUrl
                documentacionVehiculo1Url
                documentacionVehiculo2Url
                documentacionVehiculo3Url
                documentacionVehiculo4Url
                documentacionVehiculo5Url
                documentacionVehiculo6Url
                documentacionVehiculo7Url
                documentacionVehiculo8Url
                documentacionVehiculo9Url
                documentacionVehiculo10Url
                documentacionVehiculo11Url
                documentacionVehiculo12Url
`;

export const cars = (availableForQuote = false) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($availableForQuote: Boolean) {
            cars(availableForQuote: $availableForQuote) {
                id
                brand {
                    id
                    name
                }
                carModel {
                    id
                    name
                }
                category {
                    id
                    name
                }
                year
                color
                plate
                vin
                mileage
                isActive
                status
                ${CAR_DOCUMENTATION_URL_FIELDS}
            }
        }`,
        variables: { availableForQuote: !!availableForQuote }
    });
};

// Query específica para el selector de vehículos (solo datos básicos).
// availableForQuote: si es true, excluye vehículos en contratos activos.
export const carsForSelector = (availableForQuote = true) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($availableForQuote: Boolean) {
            cars(availableForQuote: $availableForQuote) {
                id
                brand {
                    name
                }
                carModel {
                    name
                }
                category {
                    name
                }
                year
                color
                plate
                vin
                mileage
                ${CAR_DOCUMENTATION_URL_FIELDS}
            }
        }`,
        variables: { availableForQuote: !!availableForQuote }
    });
};

// Detalle de vehículo (incluye URLs de documentación para precargar flujos de contrato)
export const car = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            car(id: $id) {
                id
                category {
                    id
                }
                brand {
                    id
                }
                carModel {
                    id
                }
                year
                color
                plate
                vin
                mileage
                ${CAR_DOCUMENTATION_URL_FIELDS}
            }
        }`,
        variables: { id }
    });
};
export const createCar = (carData) => {
    // Verificar si hay archivos para subir
    const fileFields = [
        { snake: 'tarjeta_circulacion', camel: 'tarjetaCirculacion' },
        { snake: 'tarjeta_circulacion_digital', camel: 'tarjetaCirculacionDigital' },
        { snake: 'licencia_conductor', camel: 'licenciaConductor' },
        { snake: 'documentacion_vehiculo_1', camel: 'documentacionVehiculo1' },
        { snake: 'documentacion_vehiculo_2', camel: 'documentacionVehiculo2' },
        { snake: 'documentacion_vehiculo_3', camel: 'documentacionVehiculo3' },
        { snake: 'documentacion_vehiculo_4', camel: 'documentacionVehiculo4' },
        { snake: 'documentacion_vehiculo_5', camel: 'documentacionVehiculo5' },
        { snake: 'documentacion_vehiculo_6', camel: 'documentacionVehiculo6' },
        { snake: 'documentacion_vehiculo_7', camel: 'documentacionVehiculo7' },
        { snake: 'documentacion_vehiculo_8', camel: 'documentacionVehiculo8' },
        { snake: 'documentacion_vehiculo_9', camel: 'documentacionVehiculo9' },
        { snake: 'documentacion_vehiculo_10', camel: 'documentacionVehiculo10' },
        { snake: 'documentacion_vehiculo_11', camel: 'documentacionVehiculo11' },
        { snake: 'documentacion_vehiculo_12', camel: 'documentacionVehiculo12' }
    ];
    
    // Verificar si hay archivos
    const hasFiles = fileFields.some(field => {
        const file = carData[field.snake] || carData[field.camel];
        return file && file instanceof File;
    });
    
    if (hasFiles) {
        // Si hay archivos, usar FormData (similar a uploadCarDocumentation)
        const formData = new FormData();
        
        // Construir variables con archivos
        const variables = {
            categoryId: carData.categoryId,
            brandId: carData.brandId,
            carModelId: carData.carModelId,
            year: parseInt(carData.year),
            color: carData.color || null,
            plate: carData.plate,
            vin: carData.vin,
            mileage: carData.mileage ? parseInt(carData.mileage) : null,
            createdById: carData.createdById
        };
        
        // Construir la lista de archivos para la query
        const fileVariables = [];
        fileFields.forEach(field => {
            const file = carData[field.snake] || carData[field.camel];
            if (file && file instanceof File) {
                fileVariables.push(field.camel);
                variables[field.camel] = null; // Se agregará al FormData
            }
        });
        
        // Construir la query GraphQL con camelCase (GraphQL convierte automáticamente)
        const query = `mutation($categoryId: ID!, $brandId: ID!, $carModelId: ID!, $year: Int!, $color: String, $plate: String!, $vin: String!, $mileage: Int, $createdById: ID!${fileVariables.map(f => `, $${f}: Upload`).join('')}) {
            createCar(categoryId: $categoryId, brandId: $brandId, carModelId: $carModelId, year: $year, color: $color, plate: $plate, vin: $vin, mileage: $mileage, createdById: $createdById${fileVariables.map(f => `, ${f}: $${f}`).join('')}) {
                car {
                    id
                    category {
                        id
                        name
                    }
                    brand {
                        id
                        name
                    }
                    carModel {
                        id
                        name
                    }
                    year
                    color
                    plate
                    vin
                    mileage
                }
                error
            }
        }`;
        
        // Agregar operaciones
        formData.append('operations', JSON.stringify({ query, variables }));
        
        // Construir el mapa de archivos para GraphQL multipart request
        const fileMapObj = {};
        let fileIndex = 0;
        fileFields.forEach(field => {
            const file = carData[field.snake] || carData[field.camel];
            if (file && file instanceof File) {
                fileMapObj[fileIndex.toString()] = [`variables.${field.camel}`];
                formData.append(fileIndex.toString(), file);
                fileIndex++;
            }
        });
        
        formData.append('map', JSON.stringify(fileMapObj));
        
        return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } else {
        // Si no hay archivos, usar la petición normal
        return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
            query: `mutation($categoryId: ID!, $brandId: ID!, $carModelId: ID!, $year: Int!, $color: String, $plate: String!, $vin: String!, $mileage: Int, $createdById: ID!) {
                createCar(categoryId: $categoryId, brandId: $brandId, carModelId: $carModelId, year: $year, color: $color, plate: $plate, vin: $vin, mileage: $mileage, createdById: $createdById) {
                    car {
                        id
                        category {
                            id
                            name
                        }
                        brand {
                            id
                            name
                        }
                        carModel {
                            id
                            name
                        }
                        year
                        color
                        plate
                        vin
                        mileage
                    }
                    error
                }
            }`,
            variables: {
                categoryId: carData.categoryId,
                brandId: carData.brandId,
                carModelId: carData.carModelId,
                year: parseInt(carData.year),
                color: carData.color || null,
                plate: carData.plate,
                vin: carData.vin,
                mileage: carData.mileage ? parseInt(carData.mileage) : null,
                createdById: carData.createdById
            }
        });
    }
};
export const updateCar = (id, carData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $categoryId: ID, $brandId: ID, $carModelId: ID, $year: Int, $color: String, $plate: String, $vin: String, $mileage: Int) {
            updateCar(id: $id, categoryId: $categoryId, brandId: $brandId, carModelId: $carModelId, year: $year, color: $color, plate: $plate, vin: $vin, mileage: $mileage) {
                car {
                    id
                    category {
                        id
                        name
                    }
                    brand {
                        id
                        name
                    }
                    carModel {
                        id
                        name
                    }
                    year
                    color
                    plate
                    vin
                    mileage
                }
                error
            }
        }`,
        variables: {
            id,
            categoryId: carData.categoryId || null,
            brandId: carData.brandId || null,
            carModelId: carData.carModelId || null,
            year: carData.year ? parseInt(carData.year) : null,
            color: carData.color || null,
            plate: carData.plate || null,
            vin: carData.vin || null,
            mileage: carData.mileage ? parseInt(carData.mileage) : null,
            // Campos de documentación
            tarjeta_circulacion: carData.tarjeta_circulacion || null,
            tarjeta_circulacion_digital: carData.tarjeta_circulacion_digital || null,
            licencia_conductor: carData.licencia_conductor || null,
            documentacion_vehiculo_1: carData.documentacion_vehiculo_1 || null,
            documentacion_vehiculo_2: carData.documentacion_vehiculo_2 || null,
            documentacion_vehiculo_3: carData.documentacion_vehiculo_3 || null,
            documentacion_vehiculo_4: carData.documentacion_vehiculo_4 || null,
            documentacion_vehiculo_5: carData.documentacion_vehiculo_5 || null,
            documentacion_vehiculo_6: carData.documentacion_vehiculo_6 || null,
            documentacion_vehiculo_7: carData.documentacion_vehiculo_7 || null,
            documentacion_vehiculo_8: carData.documentacion_vehiculo_8 || null,
            documentacion_vehiculo_9: carData.documentacion_vehiculo_9 || null,
            documentacion_vehiculo_10: carData.documentacion_vehiculo_10 || null,
            documentacion_vehiculo_11: carData.documentacion_vehiculo_11 || null,
            documentacion_vehiculo_12: carData.documentacion_vehiculo_12 || null
        }
    });
};
export const deleteCar = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteCar(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};

export const deletedCars = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            deletedCars {
                id
                plate
                vin
                year
                color
                deletedAt
                category {
                    id
                    name
                }
                brand {
                    id
                    name
                }
                carModel {
                    id
                    name
                }
                status
                createdAt
            }
        }`
    });
};

export const restoreCar = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            restoreCar(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};
export const brands = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{ brands { id name } }`
    });
};
export const categories = (activeOnly = false) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($activeOnly: Boolean) {
            categories(activeOnly: $activeOnly) { id name isActive }
        }`,
        variables: { activeOnly: !!activeOnly }
    });
};

export const toggleCategoryStatus = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            toggleCategoryStatus(id: $id) {
                category { id name isActive }
                success
                error
            }
        }`,
        variables: { id }
    });
};

export const toggleCarStatus = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            toggleCarStatus(id: $id) {
                car { id plate isActive }
                success
                error
            }
        }`,
        variables: { id }
    });
};
export const carModels = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{ 
            carModels { 
                id 
                name 
                brand {
                    id
                    name
                }
            } 
        }`
    });
};

// --- COTIZACIONES ---
export const allQuotes = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allQuotes {
                id
                folio
                asesor{
                    id
                    firstName
                    lastName
                    email
                }
                cliente{
                    id
                    firstName
                    lastName
                    mainPhone
                    email
                }
                vehiculo{
                    id
                    brand{
                        name
                    }
                    carModel{
                        name
                    }
                    year
                    plate
                }
                anio
                modelo
                tipo
                modalidad
                gpsPagadoPorCliente
                montoPrestamo
                monedaMonto
                montoPrestamoMxn
                costoGps
                costoGpsMxn
                tasaCambioVigente
                tasaInteres
                fechaCreacion
                contrato {
                    id
                }
            }
        }`
    });
};

export const quotes = (estatus = null) => {
    const estatusFilter = estatus ? `(estatus: "${estatus}")` : '';
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            quotes${estatusFilter} {
                id
                folio
                asesor{
                    id
                    firstName
                    lastName
                    email
                }
                vehiculo{
                    id
                    brand{
                        name
                    }
                    carModel{
                        name
                    }
                    year
                    plate
                    color
                    vin
                }
                anio
                modelo
                tipo
                modalidad
                gpsPagadoPorCliente
                costoGps
                costoGpsMxn
                montoPrestamo
                monedaMonto
                montoPrestamoMxn
                tasaInteres
                estatus
                motivoCancelacion
                fechaCreacion
                isDeleted
                contrato {
                    id
                    cliente {
                        id
                        firstName
                        lastName
                    }
                }
            }
        }`
    });
};

export const cancelledQuotes = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            cancelledQuotes {
                id
                folio
                asesor{
                    id
                    firstName
                    lastName
                    email
                }
                vehiculo{
                    id
                    brand{
                        name
                    }
                    carModel{
                        name
                    }
                    year
                    plate
                    color
                    vin
                }
                anio
                modelo
                tipo
                modalidad
                gpsPagadoPorCliente
                costoGps
                montoPrestamo
                tasaInteres
                estatus
                motivoCancelacion
                fechaCreacion
                ultimaModificacion
                contrato {
                    id
                    cliente {
                        id
                        firstName
                        lastName
                    }
                }
            }
        }`
    });
};

/** Obtener una cotización por ID con todos los datos para edición (vehículo, préstamo, etc.) */
export const quoteById = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            quote(id: $id) {
                id
                folio
                asesor {
                    id
                    firstName
                    lastName
                    email
                }
                vehiculo {
                    id
                    brand { id name }
                    carModel { id name }
                    category { id name }
                    year
                    plate
                    color
                    vin
                    mileage
                }
                anio
                modelo
                tipo
                modalidad
                gpsPagadoPorCliente
                costoGps
                montoPrestamo
                montoPrestamoMxn
                costoGpsMxn
                tasaCambioVigente
                tasaInteres
                estatus
                motivoCancelacion
                fechaCreacion
                contrato {
                    id
                    cliente {
                        id
                        firstName
                        lastName
                        email
                        mainPhone
                        mainCodePhone
                    }
                }
            }
        }`,
        variables: { id: String(id) }
    });
};

/** @deprecated Use quoteById for full data */
export const quote = (id) => {
    return quoteById(id);
};
export const updateQuote = (id, input) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $modalidad: String, $gpsPagadoPorCliente: Boolean, $montoPrestamo: Decimal, $monedaMonto: String, $tasaInteres: Decimal) {
            updateQuote(id: $id, modalidad: $modalidad, gpsPagadoPorCliente: $gpsPagadoPorCliente, montoPrestamo: $montoPrestamo, monedaMonto: $monedaMonto, tasaInteres: $tasaInteres) {
                quote {
                    id
                    modalidad
                    gpsPagadoPorCliente
                    montoPrestamo
                    tasaInteres
                }
                error
            }
        }`,
        variables: { 
            id, 
            modalidad: input.modalidad,
            gpsPagadoPorCliente: input.gpsPagadoPorCliente,
            montoPrestamo: input.montoPrestamo,
            monedaMonto: input.monedaMonto || input.moneda_monto || 'USD',
            tasaInteres: input.tasaInteres
        }
    });
};
export const cancelQuote = (id, motivoCancelacion) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $motivoCancelacion: String!) {
            cancelQuote(id: $id, motivoCancelacion: $motivoCancelacion) {
                quote {
                    id
                    folio
                    estatus
                    motivoCancelacion
                }
                success
                error
            }
        }`,
        variables: { id, motivoCancelacion }
    });
};

export const deleteQuote = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteQuote(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};
export const convertQuoteToContract = (quoteId, contratoId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($quoteId: ID!, $contratoId: ID!) {
            convertQuoteToContract(quoteId: $quoteId, contratoId: $contratoId) {
                contract {
                    id
                }
                error
            }
        }`,
        variables: { quoteId, contratoId }
    });
};

// --- CONTRATOS ---
export const contracts = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            contracts {
                id
                fechaFirma
                sucursal
                ejecutivo{
                id
                firstName
                lastName
                email
                }
                cliente{
                firstName
                lastName
                }
                monto
                montoLetras
                interesOrdinario
                interesMoratorio
                vehiculo{
                id
                brand{
                    name
                }
                carModel{
                    name
                }
                year
                plate
                }
                documentosEntregados
                modalidad
                medidasSeguridad
                costoInstalacion
                fechaVencimientoPrimeraParcialidad
                cartaRemolque
                anexo1
                recordatorios
                comprobantePago
                estatus
                creadoPor{
                email
                }
            }
        }`
    });
};
export const contract = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            contract(id: $id) {
                id
                fechaFirma
                sucursal
                ejecutivoId
                clienteId
                monto
                montoLetras
                interesOrdinario
                interesMoratorio
                vehiculoId
                documentosEntregados
                modalidad
                medidasSeguridad
                costoInstalacion
                fechaVencimientoPrimeraParcialidad
                cartaRemolque
                anexo1
                recordatorios
                comprobantePago
                estatus
                creadoPorId
            }
        }`,
        variables: { id }
    });
};
export const createContract = (input) => {
    // Limpiar datos: convertir cadenas vacías a null para campos Date opcionales
    const cleanedInput = { ...input };
    if (cleanedInput.fechaVencimientoPrimeraParcialidad === '' || cleanedInput.fechaVencimientoPrimeraParcialidad === undefined) {
        cleanedInput.fechaVencimientoPrimeraParcialidad = null;
    }
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($fechaFirma: Date, $sucursal: String, $ejecutivoId: ID, $clienteId: ID, $monto: Float, $montoLetras: String, $interesOrdinario: Float, $interesMoratorio: Float, $vehiculoId: ID, $documentosEntregados: String, $modalidad: String, $medidasSeguridad: String, $costoInstalacion: Float, $fechaVencimientoPrimeraParcialidad: Date, $cartaRemolque: String, $anexo1: String, $recordatorios: String, $comprobantePago: String, $estatus: String, $creadoPorId: ID) {
            createContract(fechaFirma: $fechaFirma, sucursal: $sucursal, ejecutivoId: $ejecutivoId, clienteId: $clienteId, monto: $monto, montoLetras: $montoLetras, interesOrdinario: $interesOrdinario, interesMoratorio: $interesMoratorio, vehiculoId: $vehiculoId, documentosEntregados: $documentosEntregados, modalidad: $modalidad, medidasSeguridad: $medidasSeguridad, costoInstalacion: $costoInstalacion, fechaVencimientoPrimeraParcialidad: $fechaVencimientoPrimeraParcialidad, cartaRemolque: $cartaRemolque, anexo1: $anexo1, recordatorios: $recordatorios, comprobantePago: $comprobantePago, estatus: $estatus, creadoPorId: $creadoPorId) {
                contract {
                    id
                    fechaFirma
                    sucursal
                    monto
                    modalidad
                    estatus
                }
                error
            }
        }`,
        variables: { 
            fechaFirma: cleanedInput.fechaFirma,
            sucursal: cleanedInput.sucursal,
            ejecutivoId: cleanedInput.ejecutivoId,
            clienteId: cleanedInput.clienteId,
            monto: cleanedInput.monto,
            montoLetras: cleanedInput.montoLetras,
            interesOrdinario: cleanedInput.interesOrdinario,
            interesMoratorio: cleanedInput.interesMoratorio,
            vehiculoId: cleanedInput.vehiculoId,
            documentosEntregados: cleanedInput.documentosEntregados,
            modalidad: cleanedInput.modalidad,
            medidasSeguridad: cleanedInput.medidasSeguridad,
            costoInstalacion: cleanedInput.costoInstalacion,
            fechaVencimientoPrimeraParcialidad: cleanedInput.fechaVencimientoPrimeraParcialidad,
            cartaRemolque: cleanedInput.cartaRemolque,
            anexo1: cleanedInput.anexo1,
            recordatorios: cleanedInput.recordatorios,
            comprobantePago: cleanedInput.comprobantePago,
            estatus: cleanedInput.estatus,
            creadoPorId: cleanedInput.creadoPorId
        }
    });
};
export const updateContract = (id, input) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $estatus: String, $recordatorios: String, $comprobantePago: String) {
            updateContract(id: $id, estatus: $estatus, recordatorios: $recordatorios, comprobantePago: $comprobantePago) {
                contract {
                    id
                    estatus
                    recordatorios
                    comprobantePago
                }
                error
            }
        }`,
        variables: { 
            id, 
            estatus: input.estatus,
            recordatorios: input.recordatorios,
            comprobantePago: input.comprobantePago
        }
    });
};
export const deleteContract = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteContract(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};


// Mutation: Marcar notificación como leída
export const readMessage = (obj) => {
    return axios.post(
        process.env.VUE_APP_URL_SERVICES_GRAPHQL,
        {
            query: `mutation($id:ID!){
                readNotification(id: $id){
                    info{
                        id
                        message
                        title
                        readClient
                        reservation {
                            id
                            total
                            email
                            tipoCobertura
                            dias
                            serviciosExtras
                            tarifaDiaria
                            comentarios
                            fechaRenta
                            fechaFin
                            nombre
                            apellidos
                            telefono
                            edad
                            pagoId
                            origen
                            revisado
                            noReserva
                            fecha
                            estado
                            metodoPago
                            cantidad
                            categoria {
                                id
                                name
                                tradicionalAlta
                                totalAlta
                                tradicionalBaja
                                totalBaja
                                isActive
                                fecha
                                image
                                iconoWhite
                                iconoBlack
                                maletas
                                maletasSm
                                personas
                                transmision
                                lugar
                            }
                            sucursal {
                                id
                                name
                                phone
                                contactPhone
                                address
                                postalCod
                                openHour
                                closeHour
                                isActive
                            }
                            agente {
                                id
                                username
                                firstName
                                lastName
                                email
                                isActive
                                phone
                            }
                        }
                    }
                }
            }
            `,
            variables: obj
        }
    );
};

// ===== NUEVAS FUNCIONES OPTIMIZADAS PARA COTIZACIONES =====

// Búsqueda de clientes
export const searchClients = (query) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($query: String!) {
            searchClients(query: $query) {
                id
                firstName
                lastName
                curp
                rfc
                mainPhone
                secondaryPhone
                email
                address
                ine
            }
        }`,
        variables: { query }
    });
};

// Obtener marcas por categoría
export const getBrandsByCategory = (categoryId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($categoryId: ID!) {
            brandsByCategory(categoryId: $categoryId) {
                id
                name
            }
        }`,
        variables: { categoryId }
    });
};

// Obtener modelos por marca
export const getModelsByBrand = (brandId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($brandId: ID!) {
            modelsByBrand(brandId: $brandId) {
                id
                name
            }
        }`,
        variables: { brandId }
    });
};

// Crear cotización (Administración)
export const createQuote = (quoteData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($asesorId: ID!, $vehiculoId: ID!, $anio: Int!, $modelo: String!, $tipo: String!, $modalidad: String!, $gpsPagadoPorCliente: Boolean, $montoPrestamo: Decimal!, $monedaMonto: String, $tasaInteres: Decimal, $fotos: String) {
            createQuote(asesorId: $asesorId, vehiculoId: $vehiculoId, anio: $anio, modelo: $modelo, tipo: $tipo, modalidad: $modalidad, gpsPagadoPorCliente: $gpsPagadoPorCliente, montoPrestamo: $montoPrestamo, monedaMonto: $monedaMonto, tasaInteres: $tasaInteres, fotos: $fotos) {
                quote {
                    id
                    folio
                    asesor {
                        id
                        firstName
                        lastName
                    }
                    vehiculo {
                        id
                        brand {
                            name
                        }
                        carModel {
                            name
                        }
                        year
                        plate
                        vin
                    }
                    anio
                    modelo
                    tipo
                    modalidad
                    gpsPagadoPorCliente
                    montoPrestamo
                    montoPrestamoMxn
                    costoGps
                    costoGpsMxn
                    tasaCambioUsada
                    tasaInteres
                    fechaCreacion
                }
                pdfUrl
                error
            }
        }`,
        variables: {
            asesorId: quoteData.asesorId,
            vehiculoId: quoteData.vehiculoId,
            anio: quoteData.anio,
            modelo: quoteData.modelo,
            tipo: quoteData.tipo,
            modalidad: quoteData.modalidad,
            gpsPagadoPorCliente: quoteData.gpsPagadoPorCliente === true,
            montoPrestamo: quoteData.montoPrestamo,
            monedaMonto: quoteData.monedaMonto || quoteData.moneda_monto || 'USD',
            tasaInteres: quoteData.tasaInteres || 15,
            fotos: quoteData.fotos || null
        }
    });
};

// Crear cotización (Portal Web - WhatsApp)
export const createQuoteAdvisor = (quoteData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($clienteNombre: String!, $clienteApellidos: String!, $clienteTelefono: String!, $clienteEmail: String, $marca: String!, $modelo: String!, $ano: String!, $comentarios: String) {
            createQuoteAdvisor(clienteNombre: $clienteNombre, clienteApellidos: $clienteApellidos, clienteTelefono: $clienteTelefono, clienteEmail: $clienteEmail, marca: $marca, modelo: $modelo, ano: $ano, comentarios: $comentarios) {
                response {
                    success
                    advisor {
                        id
                        firstName
                        lastName
                        phone
                    }
                    whatsappUrl
                    error
                }
            }
        }`,
        variables: {
            clienteNombre: quoteData.clienteNombre,
            clienteApellidos: quoteData.clienteApellidos,
            clienteTelefono: quoteData.clienteTelefono,
            clienteEmail: quoteData.clienteEmail || null,
            marca: quoteData.marca,
            modelo: quoteData.modelo,
            ano: quoteData.ano,
            comentarios: quoteData.comentarios || null
        }
    });
};

// Obtener detalles completos de cotización
export const getQuoteDetails = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            quoteDetails(id: $id) {
                id
                folio
                asesor {
                    id
                    firstName
                    lastName
                    email
                    phone
                }
                cliente {
                    id
                    firstName
                    lastName
                    curp
                    rfc
                    mainPhone
                    secondaryPhone
                    email
                    address
                    ine
                }
                vehiculo {
                    id
                    category {
                        id
                        name
                    }
                    brand {
                        id
                        name
                    }
                    carModel {
                        id
                        name
                    }
                    year
                    color
                    plate
                    vin
                    mileage
                    mechanicalState
                    appraisalValue
                    observations
                    photoFront
                    photoLeft
                    photoRight
                    photoBack
                }
                anio
                modelo
                tipo
                modalidad
                costoGps
                gpsPagadoPorCliente
                montoPrestamo
                montoPrestamoMxn
                costoGpsMxn
                tasaCambioVigente
                fechaCreacion
                ultimaModificacion
            }
        }`,
        variables: { id }
    });
};


// Calcular costos de préstamo
export const calculateLoanCosts = (input) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($input: LoanCalculationInput!) {
            calculateLoanCosts(input: $input) {
                montoPrestamo
                modalidad
                costoGps
                gpsPagadoPorCliente
                totalDesembolsar
                totalClientePaga
                interesMensual
                interesTotal
                pagoTotal
                plazo
                tasaInteres
            }
        }`,
        variables: { input }
    });
};

// Obtener estadísticas de cotizaciones
export const getQuoteStats = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            quoteStats {
                total
                pendientes
                canceladas
                convertidas
                montoTotal
                montoPromedio
                cotizacionesPorMes {
                    mes
                    cantidad
                    monto
                }
            }
        }`
    });
};

// ===== NOMENCLADORES =====

// --- CATEGORÍAS ---
export const createCategory = (name, description = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($name: String!, $description: String) {
            createCategory(name: $name, description: $description) {
                category {
                    id
                    name
                    description
                }
                error
            }
        }`,
        variables: { name, description }
    });
};

export const updateCategory = (id, name, description = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $name: String!, $description: String) {
            updateCategory(id: $id, name: $name, description: $description) {
                category {
                    id
                    name
                    description
                }
                error
            }
        }`,
        variables: { id, name, description }
    });
};

export const deleteCategory = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteCategory(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};

// --- MARCAS ---
export const createBrand = (name) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($name: String!) {
            createBrand(name: $name) {
                brand {
                    id
                    name
                }
                error
            }
        }`,
        variables: { name }
    });
};

export const updateBrand = (id, name) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $name: String!) {
            updateBrand(id: $id, name: $name) {
                brand {
                    id
                    name
                }
                error
            }
        }`,
        variables: { id, name }
    });
};

export const deleteBrand = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteBrand(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};

// --- MODELOS ---
export const createCarModel = (name, brandId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($name: String!, $brandId: ID!) {
            createCarModel(name: $name, brandId: $brandId) {
                carModel {
                    id
                    name
                    brand {
                        id
                        name
                    }
                }
                error
            }
        }`,
        variables: { name, brandId }
    });
};

export const updateCarModel = (id, name, brandId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $name: String!, $brandId: ID!) {
            updateCarModel(id: $id, name: $name, brandId: $brandId) {
                carModel {
                    id
                    name
                    brand {
                        id
                        name
                    }
                }
                error
            }
        }`,
        variables: { id, name, brandId }
    });
};

export const deleteCarModel = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteCarModel(id: $id) {
                ok
                error
            }
        }`,
        variables: { id }
    });
};

// --- CITAS ---
export const appointments = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            appointments {
                id
                clienteNombre
                clienteApellidos
                clienteTelefono
                clienteEmail
                fechaCita
                horaCita
                tipoServicio
                motivo
                estatus
                asesorAsignado {
                    id
                    firstName
                    lastName
                }
                gestorWhatsappInfo {
                    id
                    fullName
                    whatsappNumber
                }
                whatsappMessage
                whatsappUrl
                notasAsesor
                fechaCreacion
                fechaActualizacion
                nombreCompletoCliente
                fechaHoraCita
                puedeSerConfirmada
                puedeSerAplazada
                puedeSerCancelada
            }
        }`
    });
};

export const appointment = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            appointment(id: $id) {
                id
                clienteNombre
                clienteApellidos
                clienteTelefono
                clienteEmail
                fechaCita
                horaCita
                tipoServicio
                motivo
                estatus
                asesorAsignado {
                    id
                    firstName
                    lastName
                }
                notasAsesor
                fechaCreacion
                fechaActualizacion
                nombreCompletoCliente
                fechaHoraCita
                puedeSerConfirmada
                puedeSerAplazada
                puedeSerCancelada
            }
        }`,
        variables: { id }
    });
};

export const pendingAppointments = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            pendingAppointments {
                id
                clienteNombre
                clienteApellidos
                clienteTelefono
                clienteEmail
                fechaCita
                horaCita
                tipoServicio
                motivo
                estatus
                asesorAsignado {
                    id
                    firstName
                    lastName
                }
                notasAsesor
                fechaCreacion
                fechaActualizacion
                nombreCompletoCliente
                fechaHoraCita
                puedeSerConfirmada
                puedeSerAplazada
                puedeSerCancelada
            }
        }`
    });
};

export const confirmedAppointments = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            confirmedAppointments {
                id
                clienteNombre
                clienteApellidos
                clienteTelefono
                clienteEmail
                fechaCita
                horaCita
                tipoServicio
                motivo
                estatus
                asesorAsignado {
                    id
                    firstName
                    lastName
                }
                notasAsesor
                fechaCreacion
                fechaActualizacion
                nombreCompletoCliente
                fechaHoraCita
                puedeSerConfirmada
                puedeSerAplazada
                puedeSerCancelada
            }
        }`
    });
};

export const collectionAppointments = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            collectionAppointments {
                id
                clienteNombre
                clienteApellidos
                clienteTelefono
                clienteEmail
                fechaCita
                horaCita
                tipoServicio
                motivo
                estatus
                asesorAsignado {
                    id
                    firstName
                    lastName
                }
                gestorWhatsappInfo {
                    id
                    fullName
                    whatsappNumber
                }
                whatsappMessage
                whatsappUrl
                notasAsesor
                fechaCreacion
                fechaActualizacion
                nombreCompletoCliente
                fechaHoraCita
                puedeSerConfirmada
                puedeSerAplazada
                puedeSerCancelada
            }
        }`
    });
};

export const appointmentsByServiceType = (tipoServicio) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($tipoServicio: String!) {
            appointmentsByServiceType(tipoServicio: $tipoServicio) {
                id
                clienteNombre
                clienteApellidos
                clienteTelefono
                clienteEmail
                fechaCita
                horaCita
                tipoServicio
                motivo
                estatus
                asesorAsignado {
                    id
                    firstName
                    lastName
                }
                gestorWhatsappInfo {
                    id
                    fullName
                    whatsappNumber
                }
                whatsappMessage
                whatsappUrl
                notasAsesor
                fechaCreacion
                fechaActualizacion
                nombreCompletoCliente
                fechaHoraCita
                puedeSerConfirmada
                puedeSerAplazada
                puedeSerCancelada
            }
        }`,
        variables: { tipoServicio }
    });
};

export const advisors = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            advisors {
                id
                firstName
                lastName
                email
                username
                nombreCompleto
            }
        }`
    });
};

export const createAppointment = (appointmentData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($clienteNombre: String!, $clienteApellidos: String!, $clienteTelefono: String!, $clienteEmail: String, $fechaCita: Date!, $horaCita: Time!, $tipoServicio: String!, $motivo: String!) {
            createAppointment(
                clienteNombre: $clienteNombre,
                clienteApellidos: $clienteApellidos,
                clienteTelefono: $clienteTelefono,
                clienteEmail: $clienteEmail,
                fechaCita: $fechaCita,
                horaCita: $horaCita,
                tipoServicio: $tipoServicio,
                motivo: $motivo
            ) {
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    clienteTelefono
                    clienteEmail
                    fechaCita
                    horaCita
                    tipoServicio
                    motivo
                    estatus
                    fechaCreacion
                    nombreCompletoCliente
                    fechaHoraCita
                }
                success
                error
            }
        }`,
        variables: appointmentData
    });
};

export const updateAppointment = (id, appointmentData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $estatus: String, $asesorAsignadoId: ID, $notasAsesor: String, $fechaCita: Date, $horaCita: Time) {
            updateAppointment(
                id: $id,
                estatus: $estatus,
                asesorAsignadoId: $asesorAsignadoId,
                notasAsesor: $notasAsesor,
                fechaCita: $fechaCita,
                horaCita: $horaCita
            ) {
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    clienteTelefono
                    clienteEmail
                    fechaCita
                    horaCita
                    tipoServicio
                    motivo
                    estatus
                    asesorAsignado {
                        id
                        firstName
                        lastName
                    }
                    notasAsesor
                    fechaCreacion
                    fechaActualizacion
                    nombreCompletoCliente
                    fechaHoraCita
                    puedeSerConfirmada
                    puedeSerAplazada
                    puedeSerCancelada
                }
                success
                error
            }
        }`,
        variables: { id, ...appointmentData }
    });
};

export const confirmAppointment = (id, asesorAsignadoId = null, notasAsesor = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $asesorAsignadoId: ID, $notasAsesor: String) {
            confirmAppointment(
                id: $id,
                asesorAsignadoId: $asesorAsignadoId,
                notasAsesor: $notasAsesor
            ) {
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    clienteTelefono
                    clienteEmail
                    fechaCita
                    horaCita
                    tipoServicio
                    motivo
                    estatus
                    asesorAsignado {
                        id
                        firstName
                        lastName
                    }
                    notasAsesor
                    fechaCreacion
                    fechaActualizacion
                    nombreCompletoCliente
                    fechaHoraCita
                    puedeSerConfirmada
                    puedeSerAplazada
                    puedeSerCancelada
                }
                success
                error
            }
        }`,
        variables: { id, asesorAsignadoId, notasAsesor }
    });
};

export const rescheduleAppointment = (id, nuevaFecha, nuevaHora, motivoAplazamiento = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $nuevaFecha: Date!, $nuevaHora: Time!, $motivoAplazamiento: String) {
            rescheduleAppointment(
                id: $id,
                nuevaFecha: $nuevaFecha,
                nuevaHora: $nuevaHora,
                motivoAplazamiento: $motivoAplazamiento
            ) {
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    clienteTelefono
                    clienteEmail
                    fechaCita
                    horaCita
                    tipoServicio
                    motivo
                    estatus
                    asesorAsignado {
                        id
                        firstName
                        lastName
                    }
                    notasAsesor
                    fechaCreacion
                    fechaActualizacion
                    nombreCompletoCliente
                    fechaHoraCita
                    puedeSerConfirmada
                    puedeSerAplazada
                    puedeSerCancelada
                }
                success
                error
            }
        }`,
        variables: { id, nuevaFecha, nuevaHora, motivoAplazamiento }
    });
};

export const cancelAppointment = (id, motivoCancelacion = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $motivoCancelacion: String) {
            cancelAppointment(
                id: $id,
                motivoCancelacion: $motivoCancelacion
            ) {
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    clienteTelefono
                    clienteEmail
                    fechaCita
                    horaCita
                    tipoServicio
                    motivo
                    estatus
                    asesorAsignado {
                        id
                        firstName
                        lastName
                    }
                    notasAsesor
                    fechaCreacion
                    fechaActualizacion
                    nombreCompletoCliente
                    fechaHoraCita
                    puedeSerConfirmada
                    puedeSerAplazada
                    puedeSerCancelada
                }
                success
                error
            }
        }`,
        variables: { id, motivoCancelacion }
    });
};

export const acceptAppointment = (id, asesorAsignadoId = null, notasAsesor = null, enviarEmail = true) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $asesorAsignadoId: ID, $notasAsesor: String, $enviarEmail: Boolean) {
            acceptAppointment(
                id: $id,
                asesorAsignadoId: $asesorAsignadoId,
                notasAsesor: $notasAsesor,
                enviarEmail: $enviarEmail
            ) {
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    clienteTelefono
                    clienteEmail
                    fechaCita
                    horaCita
                    tipoServicio
                    motivo
                    estatus
                    asesorAsignado {
                        id
                        firstName
                        lastName
                    }
                    notasAsesor
                    fechaCreacion
                    fechaActualizacion
                    nombreCompletoCliente
                    fechaHoraCita
                    puedeSerConfirmada
                    puedeSerAplazada
                    puedeSerCancelada
                }
                success
                error
                emailEnviado
            }
        }`,
        variables: { id, asesorAsignadoId, notasAsesor, enviarEmail }
    });
};

// --- NOTIFICACIONES DE CITAS ---
export const myAppointmentNotifications = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            myAppointmentNotifications {
                id
                read
                fechaCreacion
                titulo
                mensaje
                tipoServicioDisplay
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    clienteTelefono
                    clienteEmail
                    fechaCita
                    horaCita
                    tipoServicio
                    motivo
                    estatus
                    nombreCompletoCliente
                    fechaHoraCita
                }
            }
        }`
    });
};

export const unreadAppointmentNotifications = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            unreadAppointmentNotifications {
                id
                read
                fechaCreacion
                titulo
                mensaje
                tipoServicioDisplay
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    clienteTelefono
                    clienteEmail
                    fechaCita
                    horaCita
                    tipoServicio
                    motivo
                    estatus
                    nombreCompletoCliente
                    fechaHoraCita
                }
            }
        }`
    });
};

export const unreadAppointmentNotificationsCount = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            unreadAppointmentNotificationsCount
        }`
    });
};

export const markNotificationAsRead = (notificationId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($notificationId: ID!) {
            markNotificationAsRead(notificationId: $notificationId) {
                notification {
                    id
                    read
                }
                success
                error
            }
        }`,
        variables: { notificationId }
    });
};

export const markAllNotificationsAsRead = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation {
            markAllNotificationsAsRead {
                success
                error
                markedCount
            }
        }`
    });
};

// ===== PAÍSES Y ESTADOS =====

// --- PAÍSES ---
export const countries = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allCountries {
                id
                name
                code
                phoneCode
                isActive
                createdAt
                updatedAt
            }
        }`
    });
};

export const country = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            country(id: $id) {
                id
                name
                code
                phoneCode
                isActive
                createdAt
                updatedAt
            }
        }`,
        variables: { id }
    });
};

export const createCountry = (countryData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($name: String!, $code: String!, $phoneCode: String) {
            createCountry(name: $name, code: $code, phoneCode: $phoneCode) {
                country {
                    id
                    name
                    code
                    phoneCode
                    isActive
                }
                success
                message
            }
        }`,
        variables: countryData
    });
};

export const updateCountry = (id, countryData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $name: String, $code: String, $phoneCode: String, $isActive: Boolean) {
            updateCountry(id: $id, name: $name, code: $code, phoneCode: $phoneCode, isActive: $isActive) {
                country {
                    id
                    name
                    code
                    phoneCode
                    isActive
                }
                success
                message
            }
        }`,
        variables: { id, ...countryData }
    });
};

export const deleteCountry = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteCountry(id: $id) {
                success
                message
            }
        }`,
        variables: { id }
    });
};

// --- ESTADOS ---
export const states = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allStates {
                id
                name
                code
                isActive
                createdAt
                updatedAt
                country {
                    id
                    name
                    code
                }
            }
        }`
    });
};

export const state = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            state(id: $id) {
                id
                name
                code
                isActive
                createdAt
                updatedAt
                country {
                    id
                    name
                    code
                }
            }
        }`,
        variables: { id }
    });
};


export const createState = (stateData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($name: String!, $code: String, $countryId: ID!) {
            createState(name: $name, code: $code, countryId: $countryId) {
                state {
                    id
                    name
                    code
                    isActive
                    country {
                        id
                        name
                        code
                    }
                }
                success
                message
            }
        }`,
        variables: stateData
    });
};

export const updateState = (id, stateData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $name: String, $code: String, $countryId: ID, $isActive: Boolean) {
            updateState(id: $id, name: $name, code: $code, countryId: $countryId, isActive: $isActive) {
                state {
                    id
                    name
                    code
                    isActive
                    country {
                        id
                        name
                        code
                    }
                }
                success
                message
            }
        }`,
        variables: { id, ...stateData }
    });
};

export const deleteState = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteState(id: $id) {
                success
                message
            }
        }`,
        variables: { id }
    });
};

// ===== GESTORES DE WHATSAPP =====

// --- QUERIES ---
export const allManagers = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allManagers {
                id
                fullName
                whatsappNumber
                isActive
                currentAppointmentsCount
                maxAppointmentsPerDay
                totalAppointmentsHandled
                lastAssignmentDate
                canReceiveAppointments
                appointmentsToday
                totalAppointmentsThisMonth
                pendingAppointments
                user {
                    id
                    firstName
                    lastName
                    email
                    username
                }
            }
        }`
    });
};

export const managerById = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            managerById(id: $id) {
                id
                fullName
                whatsappNumber
                isActive
                currentAppointmentsCount
                maxAppointmentsPerDay
                totalAppointmentsHandled
                lastAssignmentDate
                canReceiveAppointments
                appointmentsToday
                totalAppointmentsThisMonth
                pendingAppointments
                user {
                    id
                    firstName
                    lastName
                    email
                    username
                }
            }
        }`,
        variables: { id }
    });
};

export const activeManagers = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            activeManagers {
                id
                fullName
                whatsappNumber
                currentAppointmentsCount
                maxAppointmentsPerDay
                canReceiveAppointments
                user {
                    id
                    firstName
                    lastName
                    email
                }
            }
        }`
    });
};

export const availableManagers = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            availableManagers {
                id
                fullName
                whatsappNumber
                currentAppointmentsCount
                maxAppointmentsPerDay
                user {
                    id
                    firstName
                    lastName
                    email
                }
            }
        }`
    });
};

export const managerStats = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            managerStats {
                totalManagers
                activeManagers
                totalAppointmentsToday
                totalAppointmentsThisMonth
                averageAppointmentsPerManager
            }
        }`
    });
};

export const managerPerformance = (startDate = null, endDate = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($startDate: Date, $endDate: Date) {
            managerPerformance(startDate: $startDate, endDate: $endDate) {
                id
                fullName
                whatsappNumber
                currentAppointmentsCount
                maxAppointmentsPerDay
                totalAppointmentsHandled
                appointmentsInRange
                user {
                    id
                    firstName
                    lastName
                    email
                }
            }
        }`,
        variables: { startDate, endDate }
    });
};

// --- MUTATIONS ---
export const createManager = (managerData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($userId: ID!, $whatsappNumber: String!, $maxAppointmentsPerDay: Int, $isActive: Boolean) {
            createManager(
                userId: $userId,
                whatsappNumber: $whatsappNumber,
                maxAppointmentsPerDay: $maxAppointmentsPerDay,
                isActive: $isActive
            ) {
                manager {
                    id
                    fullName
                    whatsappNumber
                    isActive
                    maxAppointmentsPerDay
                    currentAppointmentsCount
                    totalAppointmentsHandled
                    user {
                        id
                        firstName
                        lastName
                        email
                    }
                }
                success
                error
            }
        }`,
        variables: managerData
    });
};

export const updateManager = (id, managerData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $whatsappNumber: String, $maxAppointmentsPerDay: Int, $isActive: Boolean) {
            updateManager(
                id: $id,
                whatsappNumber: $whatsappNumber,
                maxAppointmentsPerDay: $maxAppointmentsPerDay,
                isActive: $isActive
            ) {
                manager {
                    id
                    fullName
                    whatsappNumber
                    isActive
                    maxAppointmentsPerDay
                    currentAppointmentsCount
                    totalAppointmentsHandled
                    user {
                        id
                        firstName
                        lastName
                        email
                    }
                }
                success
                error
            }
        }`,
        variables: { id, ...managerData }
    });
};

export const deleteManager = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteManager(id: $id) {
                success
                error
            }
        }`,
        variables: { id }
    });
};

export const resetManagerDailyCounter = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            resetManagerDailyCounter(id: $id) {
                manager {
                    id
                    fullName
                    currentAppointmentsCount
                    lastAssignmentDate
                }
                success
                error
            }
        }`,
        variables: { id }
    });
};

export const reassignAppointmentManager = (appointmentId, managerId = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($appointmentId: ID!, $managerId: ID) {
            reassignAppointmentManager(
                appointmentId: $appointmentId,
                managerId: $managerId
            ) {
                appointment {
                    id
                    clienteNombre
                    clienteApellidos
                    gestorWhatsappInfo {
                        id
                        fullName
                        whatsappNumber
                    }
                    whatsappMessage
                    whatsappUrl
                }
                success
                error
            }
        }`,
        variables: { appointmentId, managerId }
    });
};

// ===== QUERIES DE PAÍSES Y ESTADOS =====

export const allCountries = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            allCountries {
                id
                name
                code
                phoneCode
                isActive
            }
        }`
    });
};

export const allStates = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            allStates {
                id
                name
                code
                country {
                    id
                    name
                }
                isActive
            }
        }`
    });
};

export const statesByCountry = (countryId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($countryId: ID!) {
            statesByCountry(countryId: $countryId) {
                id
                name
                code
                isActive
            }
        }`,
        variables: { countryId }
    });
};

// ===== QUERIES DE SUCURSALES =====

export const allBranches = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            allBranches {
                id
                name
                address
                state {
                    id
                    name
                }
                country {
                    id
                    name
                }
                phonePrimary
                codPrimary
                phoneSecondary
                codSecondary
                email
                openingTime
                closingTime
                isActive
                fullAddress
                isOpenNow
                todayHours
                weeklySchedule
                stateName
                countryName
                createdAt
                updatedAt
            }
        }`
    });
};

export const branchById = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            branchById(id: $id) {
                id
                name
                address
                state
                country
                phonePrimary
                codPrimary
                phoneSecondary
                codSecondary
                email
                openingTime
                closingTime
                isActive
                fullAddress
                isOpenNow
                todayHours
                weeklySchedule
                createdAt
                updatedAt
            }
        }`,
        variables: { id }
    });
};

export const activeBranches = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            activeBranches {
                id
                name
                address
                state
                country
                phonePrimary
                email
                isOpenNow
                todayHours
                fullAddress
            }
        }`
    });
};

export const mainBranch = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            mainBranch {
                id
                name
                address
                state
                country
                phonePrimary
                email
                isOpenNow
                todayHours
                fullAddress
            }
        }`
    });
};

export const searchBranches = (query) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($query: String!) {
            searchBranches(query: $query) {
                id
                name
                address
                state
                country
                phonePrimary
                isOpenNow
                fullAddress
            }
        }`,
        variables: { query }
    });
};

export const openBranches = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            openBranches {
                id
                name
                address
                state
                country
                phonePrimary
                isOpenNow
                todayHours
                fullAddress
            }
        }`
    });
};

// ===== MUTACIONES DE SUCURSALES =====

export const createBranch = (branchData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($name: String!, $address: String!, $stateId: ID!, $countryId: ID!, $phonePrimary: String!, $codPrimary: String, $phoneSecondary: String, $codSecondary: String, $email: String, $openingTime: Time, $closingTime: Time, $isActive: Boolean) {
            createBranch(
                name: $name,
                address: $address,
                stateId: $stateId,
                countryId: $countryId,
                phonePrimary: $phonePrimary,
                codPrimary: $codPrimary,
                phoneSecondary: $phoneSecondary,
                codSecondary: $codSecondary,
                email: $email,
                openingTime: $openingTime,
                closingTime: $closingTime,
                isActive: $isActive
            ) {
                branch {
                    id
                    name
                    address
                    state {
                        id
                        name
                    }
                    country {
                        id
                        name
                    }
                    phonePrimary
                    email
                    isActive
                    fullAddress
                }
                success
                error
            }
        }`,
        variables: branchData
    });
};

export const updateBranch = (id, branchData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $name: String, $address: String, $stateId: ID, $countryId: ID, $phonePrimary: String, $codPrimary: String, $phoneSecondary: String, $codSecondary: String, $email: String, $openingTime: Time, $closingTime: Time, $isActive: Boolean) {
            updateBranch(
                id: $id,
                name: $name,
                address: $address,
                stateId: $stateId,
                countryId: $countryId,
                phonePrimary: $phonePrimary,
                codPrimary: $codPrimary,
                phoneSecondary: $phoneSecondary,
                codSecondary: $codSecondary,
                email: $email,
                openingTime: $openingTime,
                closingTime: $closingTime,
                isActive: $isActive
            ) {
                branch {
                    id
                    name
                    address
                    state {
                        id
                        name
                    }
                    country {
                        id
                        name
                    }
                    phonePrimary
                    email
                    isActive
                    fullAddress
                }
                success
                error
            }
        }`,
        variables: { id, ...branchData }
    });
};

export const deleteBranch = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteBranch(id: $id) {
                success
                error
            }
        }`,
        variables: { id }
    });
};

export const toggleBranchStatus = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            toggleBranchStatus(id: $id) {
                branch {
                    id
                    name
                    isActive
                }
                success
                error
            }
        }`,
        variables: { id }
    });
};

// ===== CONTRATOS =====

// --- MUTATIONS ---
// Cancelar contrato
export const cancelContract = (contractId, motivo, recuperarBien, cambiarModalidad, notas = '') => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `
            mutation CancelContract($input: CancelContractInput!) {
                cancelContract(input: $input) {
                    success
                    message
                    newContractId
                    error
                }
            }
        `,
        variables: {
            input: {
                contractId,
                motivoCancelacion: motivo,
                recuperarBien,
                cambiarModalidad,
                notas
            }
        }
    });
};

// --- QUERIES ---
export const allContracts = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allContracts {
                id
                folio
                fechaFirma
                contratoFirmado
                sucursal {
                    id
                    name
                }
                ejecutivo {
                    id
                    firstName
                    lastName
                    email
                }
                cliente {
                    id
                    firstName
                    lastName
                    email
                }
                vehiculo {
                    id
                    brand {
                        name
                    }
                    carModel {
                        name
                    }
                    year
                    color
                }
                montoPrestamo
                monedaPrestamo
                montoLetras
                interesOrdinario
                interesMoratorio
                modalidad
                costoGps
                gpsPagadoPorCliente
                fechaVencimientoPrimeraParcialidad
                copiaLlave
                estatus
                fechaCreacion
                ultimaModificacion
                totalFotosVehiculo
                totalFotosDocumentacion
                nombreCompletoCliente
                fotosVehiculoList {
                    id
                    tipoFoto
                    descripcion
                    foto
                    fechaSubida
                }
                fotosDocumentosList {
                    id
                    tipoDocumento
                    descripcion
                    esObligatorio
                    foto
                    fechaSubida
                }
            }
        }`
    });
};

export const contractById = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            contractById(id: $id) {
                id
                folio
                fechaFirma
                sucursal {
                    id
                    name
                }
                ejecutivo {
                    id
                    firstName
                    lastName
                    email
                }
                cliente {
                    id
                    firstName
                    lastName
                    email
                }
                vehiculo {
                    id
                    brand {
                        name
                    }
                    carModel {
                        name
                    }
                    year
                    color
                }
                montoPrestamo
                monedaPrestamo
                montoPrestamoMxn
                costoGpsMxn
                tasaCambioVigente
                montoLetras
                interesOrdinario
                interesMoratorio
                modalidad
                costoGps
                gpsPagadoPorCliente
                fechaVencimientoPrimeraParcialidad
                copiaLlave
                estatus
                fechaCreacion
                ultimaModificacion
                totalFotosVehiculo
                totalFotosDocumentacion
                nombreCompletoCliente
                contratoFirmado
                fotosVehiculoList {
                    id
                    tipoFoto
                    descripcion
                    foto
                    fechaSubida
                }
                fotosDocumentosList {
                    id
                    tipoDocumento
                    descripcion
                    esObligatorio
                    foto
                    fechaSubida
                }
                documentacionVehiculo {
                    tarjetaCirculacion
                    tarjetaCirculacionDigital
                    ineCliente
                    licenciaCliente
                    documentacionVehiculo1
                    documentacionVehiculo2
                    documentacionVehiculo3
                    documentacionVehiculo4
                    documentacionVehiculo5
                    documentacionVehiculo6
                    documentacionVehiculo7
                    documentacionVehiculo8
                    documentacionVehiculo9
                    documentacionVehiculo10
                    documentacionVehiculo11
                    documentacionVehiculo12
                }
            }
        }`,
        variables: { id }
    });
};

export const contractStats = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            contractStats {
                totalContracts
                activeContracts
                expiredContracts
                canceledContracts
                contractsThisMonth
                totalAmount
                averageAmount
            }
        }`
    });
};

/** Dashboard: estadísticas consolidadas (estado financiero y general) */
export const getDashboardStats = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            dashboardStats {
                totalContracts
                activeContracts
                expiredContracts
                canceledContracts
                contractsThisMonth
                totalAmountLoans
                totalClients
                totalQuotesPending
                totalVehiclesActive
                totalPaymentsReceived
                totalInterestReceived
                capitalPending
                paymentsCount
            }
        }`
    });
};

/** Dashboard: últimos contratos para el listado */
export const getDashboardRecentContracts = (limit = 5) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($limit: Int) {
            dashboardRecentContracts(limit: $limit) {
                id
                folio
                clienteNombre
                vehiculoDesc
                monto
                estatus
                fechaCreacion
            }
        }`,
        variables: { limit }
    });
};

/** Dashboard: ranking marca/modelo más cotizados */
export const getDashboardVehicleRanking = (limit = 10) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($limit: Int) {
            dashboardVehicleRanking(limit: $limit) {
                brand
                model
                count
            }
        }`,
        variables: { limit }
    });
};

/** Dashboard: ejecutivos con más cotizaciones */
export const getDashboardExecutiveQuoteRanking = (limit = 10) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($limit: Int) {
            dashboardExecutiveQuoteRanking(limit: $limit) {
                ejecutivoId
                ejecutivoNombre
                totalCotizaciones
            }
        }`,
        variables: { limit }
    });
};

// --- MUTATIONS ---
export const createContractFromQuote = (data) => {
    // Limpiar datos: convertir cadenas vacías a null para campos Date opcionales
    const cleanedData = { ...data };
    if (cleanedData.fechaVencimientoPrimeraParcialidad === '' || cleanedData.fechaVencimientoPrimeraParcialidad === undefined) {
        cleanedData.fechaVencimientoPrimeraParcialidad = null;
    }
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($cotizacionId: ID!, $clienteId: ID!, $fechaFirma: Date!, $sucursalId: ID!, $ejecutivoId: ID!, $montoPrestamo: Float, $montoLetras: String, $interesOrdinario: Float, $interesMoratorio: Float, $modalidad: String, $costoGps: Float, $gpsPagadoPorCliente: Boolean, $fechaVencimientoPrimeraParcialidad: Date, $copiaLlave: String, $notasAdicionales: String, $recordatorios: String) {
            createContractFromQuote(
                cotizacionId: $cotizacionId
                clienteId: $clienteId
                fechaFirma: $fechaFirma
                sucursalId: $sucursalId
                ejecutivoId: $ejecutivoId
                montoPrestamo: $montoPrestamo
                montoLetras: $montoLetras
                interesOrdinario: $interesOrdinario
                interesMoratorio: $interesMoratorio
                modalidad: $modalidad
                costoGps: $costoGps
                gpsPagadoPorCliente: $gpsPagadoPorCliente
                fechaVencimientoPrimeraParcialidad: $fechaVencimientoPrimeraParcialidad
                copiaLlave: $copiaLlave
                notasAdicionales: $notasAdicionales
                recordatorios: $recordatorios
            ) {
                success
                contract {
                    id
                    folio
                    cliente { id }
                    vehiculo { id }
                }
                error
            }
        }`,
        variables: cleanedData
    });
};

export const createQuoteAndContract = (data) => {
    // Limpiar datos: convertir cadenas vacías a null para campos Date opcionales
    const cleanedData = { ...data };
    if (cleanedData.fechaVencimientoPrimeraParcialidad === '' || cleanedData.fechaVencimientoPrimeraParcialidad === undefined) {
        cleanedData.fechaVencimientoPrimeraParcialidad = null;
    }
    cleanedData.moneda_monto = cleanedData.monedaMonto || cleanedData.moneda_monto || 'USD';
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($asesorId: ID!, $clienteId: ID, $clienteNuevo: JSONString, $vehiculoId: ID!, $anio: Int!, $modelo: String!, $tipo: String!, $modalidad: String!, $montoPrestamo: Decimal!, $moneda_monto: String, $gpsPagadoPorCliente: Boolean, $fechaFirma: Date!, $sucursalId: ID!, $ejecutivoId: ID!, $montoLetras: String, $interesOrdinario: Float, $interesMoratorio: Float, $costoGps: Float, $fechaVencimientoPrimeraParcialidad: Date, $copiaLlave: String, $notasAdicionales: String, $recordatorios: String) {
            createQuoteAndContract(
                asesorId: $asesorId
                clienteId: $clienteId
                clienteNuevo: $clienteNuevo
                vehiculoId: $vehiculoId
                anio: $anio
                modelo: $modelo
                tipo: $tipo
                modalidad: $modalidad
                montoPrestamo: $montoPrestamo
                moneda_monto: $moneda_monto
                gpsPagadoPorCliente: $gpsPagadoPorCliente
                fechaFirma: $fechaFirma
                sucursalId: $sucursalId
                ejecutivoId: $ejecutivoId
                montoLetras: $montoLetras
                interesOrdinario: $interesOrdinario
                interesMoratorio: $interesMoratorio
                costoGps: $costoGps
                fechaVencimientoPrimeraParcialidad: $fechaVencimientoPrimeraParcialidad
                copiaLlave: $copiaLlave
                notasAdicionales: $notasAdicionales
                recordatorios: $recordatorios
            ) {
                success
                quote {
                    id
                    folio
                }
                contract {
                    id
                    folio
                }
                error
            }
        }`,
        variables: cleanedData
    });
};

export const updateContractData = (id, data) => {
    // Usar camelCase directamente para GraphQL
    const graphqlData = {};
    if (data.estatus !== undefined) graphqlData.estatus = data.estatus;
    if (data.recordatorios !== undefined) graphqlData.recordatorios = data.recordatorios;
    if (data.notasAdicionales !== undefined) graphqlData.notasAdicionales = data.notasAdicionales;
    if (data.montoPrestamo !== undefined) graphqlData.montoPrestamo = data.montoPrestamo;
    if (data.montoLetras !== undefined) graphqlData.montoLetras = data.montoLetras;
    if (data.interesOrdinario !== undefined) graphqlData.interesOrdinario = data.interesOrdinario;
    if (data.interesMoratorio !== undefined) graphqlData.interesMoratorio = data.interesMoratorio;
    if (data.modalidad !== undefined) graphqlData.modalidad = data.modalidad;
    if (data.costoGps !== undefined) graphqlData.costoGps = data.costoGps;
    if (data.gpsPagadoPorCliente !== undefined) graphqlData.gpsPagadoPorCliente = data.gpsPagadoPorCliente;
    if (data.fechaVencimientoPrimeraParcialidad !== undefined) graphqlData.fechaVencimientoPrimeraParcialidad = data.fechaVencimientoPrimeraParcialidad;
    if (data.copiaLlave !== undefined) graphqlData.copiaLlave = data.copiaLlave;
    if (data.motivoModificacion !== undefined) graphqlData.motivoModificacion = data.motivoModificacion;
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $estatus: String, $recordatorios: String, $notasAdicionales: String, $montoPrestamo: Float, $montoLetras: String, $interesOrdinario: Float, $interesMoratorio: Float, $modalidad: String, $costoGps: Float, $gpsPagadoPorCliente: Boolean, $fechaVencimientoPrimeraParcialidad: Date, $copiaLlave: String, $motivoModificacion: String) {
            updateContract(
                id: $id
                estatus: $estatus
                recordatorios: $recordatorios
                notasAdicionales: $notasAdicionales
                montoPrestamo: $montoPrestamo
                montoLetras: $montoLetras
                interesOrdinario: $interesOrdinario
                interesMoratorio: $interesMoratorio
                modalidad: $modalidad
                costoGps: $costoGps
                gpsPagadoPorCliente: $gpsPagadoPorCliente
                fechaVencimientoPrimeraParcialidad: $fechaVencimientoPrimeraParcialidad
                copiaLlave: $copiaLlave
                motivoModificacion: $motivoModificacion
            ) {
                success
                contract {
                    id
                    folio
                }
                error
            }
        }`,
        variables: { id, ...graphqlData }
    });
};

export const deleteContractData = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteContract(id: $id) {
                success
                error
            }
        }`,
        variables: { id }
    });
};

export const addVehiclePhoto = (data) => {
    const file = data.foto instanceof File ? data.foto : null;
    if (!file) {
        return Promise.reject(new Error('No se recibió un archivo válido para subir'));
    }

    const formData = new FormData();
    formData.append('operations', JSON.stringify({
        query: `mutation($contractId: ID!, $foto: Upload!, $tipoFoto: String!, $descripcion: String, $orden: Int) {
            addVehiclePhoto(
                contractId: $contractId
                foto: $foto
                tipoFoto: $tipoFoto
                descripcion: $descripcion
                orden: $orden
            ) {
                success
                vehiclePhoto {
                    id
                    tipoFoto
                    descripcion
                }
                error
            }
        }`,
        variables: {
            contractId: data.contractId != null ? String(data.contractId) : data.contractId,
            foto: null,
            tipoFoto: data.tipoFoto,
            descripcion: data.descripcion || null,
            orden: data.orden || 0
        }
    }));
    formData.append('map', JSON.stringify({ '0': ['variables.foto'] }));
    formData.append('0', file);

    const token = getToken();
    const headers = { 'Content-Type': 'multipart/form-data' };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, { headers });
};

export const addDocumentPhoto = (data) => {
    const formData = new FormData();
    
    // Agregar operaciones GraphQL
    formData.append('operations', JSON.stringify({
        query: `mutation($contractId: ID!, $foto: Upload!, $tipoDocumento: String!, $descripcion: String, $esObligatorio: Boolean, $orden: Int) {
            addDocumentPhoto(
                contractId: $contractId
                foto: $foto
                tipoDocumento: $tipoDocumento
                descripcion: $descripcion
                esObligatorio: $esObligatorio
                orden: $orden
            ) {
                success
                documentPhoto {
                    id
                    tipoDocumento
                    descripcion
                }
                error
            }
        }`,
        variables: {
            contractId: data.contractId,
            foto: data.foto ? null : null, // Se mapeará en el map
            tipoDocumento: data.tipoDocumento,
            descripcion: data.descripcion || null,
            esObligatorio: data.esObligatorio !== undefined ? data.esObligatorio : true,
            orden: data.orden || 0
        }
    }));
    
    // Mapear archivo
    const map = {};
    let fileIndex = 0;
    
    if (data.foto) {
        map[fileIndex] = ['variables.foto'];
        formData.append(fileIndex.toString(), data.foto);
        fileIndex++;
    }
    
    formData.append('map', JSON.stringify(map));
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const deleteVehiclePhoto = (photoId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($photoId: ID!) {
            deleteVehiclePhoto(photoId: $photoId) {
                success
                error
            }
        }`,
        variables: { photoId }
    });
};

export const deleteDocumentPhoto = (photoId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($photoId: ID!) {
            deleteDocumentPhoto(photoId: $photoId) {
                success
                error
            }
        }`,
        variables: { photoId }
    });
};

// ===== PAGOS PLANIFICADOS =====

// Fragmento reutilizable para campos de pago planificado (calendario y listados)
const PAYMENT_SCHEDULE_FIELDS = `
    id
    fechaVencimiento
    montoTotalEsperado
    montoInteresEsperado
    montoCapitalEsperado
    estatus
    interesPendiente
    fechaUltimoPagoParcial
    estaVencido
    diasAtraso
    interesMoratorioCalculado
    montoTotalConMoratorio
    congelarRecargo
    fechaCongelamientoRecargo
    saldoPendienteInteres
    cliente {
        id
        firstName
        lastName
    }
    contrato {
        id
        folio
        interesMoratorio
        monedaPrestamo
        sucursal {
            id
            name
        }
    }
`;

// Query: Obtener todos los pagos planificados (evitar en producción; preferir paymentSchedulesForCalendar)
export const allPaymentSchedules = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{ allPaymentSchedules { ${PAYMENT_SCHEDULE_FIELDS} } }`
    }).catch(error => {
        console.error('Error en allPaymentSchedules:', error);
        console.error('Response:', error.response);
        throw error;
    });
};

// Query: Pagos en rango de fechas para el calendario (evita timeout; filtrar por cliente/sucursal opcional)
export const paymentSchedulesForCalendar = (fechaInicio, fechaFin, clienteId = null, sucursalId = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($fechaInicio: String!, $fechaFin: String!, $clienteId: ID, $sucursalId: ID) {
            paymentSchedulesForCalendar(fechaInicio: $fechaInicio, fechaFin: $fechaFin, clienteId: $clienteId, sucursalId: $sucursalId) {
                ${PAYMENT_SCHEDULE_FIELDS}
            }
        }`,
        variables: {
            fechaInicio,
            fechaFin,
            clienteId: clienteId || null,
            sucursalId: sucursalId || null
        }
    }).catch(error => {
        console.error('Error en paymentSchedulesForCalendar:', error);
        console.error('Response:', error.response);
        throw error;
    });
};

// Query: Obtener pagos planificados por contrato
export const paymentSchedulesByContract = (contractId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($contractId: ID!) {
            paymentSchedulesByContract(contractId: $contractId) {
                id
                fechaVencimiento
                montoTotalEsperado
                montoInteresEsperado
                montoCapitalEsperado
                estatus
                interesPendiente
                fechaUltimoPagoParcial
                estaVencido
                diasAtraso
                interesMoratorioCalculado
                montoTotalConMoratorio
                cliente {
                    id
                    firstName
                    lastName
                }
                contrato {
                    id
                    folio
                    interesMoratorio
                }
            }
        }`,
        variables: { contractId }
    });
};

// Query: Obtener pagos planificados por cliente
export const paymentSchedulesByClient = (clientId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($clientId: ID!) {
            paymentSchedulesByClient(clientId: $clientId) {
                id
                fechaVencimiento
                montoTotalEsperado
                estatus
                cliente {
                    id
                    firstName
                    lastName
                }
                contrato {
                    id
                    folio
                }
            }
        }`,
        variables: { clientId }
    });
};

// Mutation: Crear pago planificado
export const createPaymentSchedule = (paymentScheduleData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($contratoId: ID!, $clienteId: ID!, $fechaVencimiento: Date!, $montoCapitalEsperado: Float!, $montoInteresEsperado: Float!, $montoTotalEsperado: Float!, $estatus: String, $notas: String) {
            createPaymentSchedule(
                contratoId: $contratoId,
                clienteId: $clienteId,
                fechaVencimiento: $fechaVencimiento,
                montoCapitalEsperado: $montoCapitalEsperado,
                montoInteresEsperado: $montoInteresEsperado,
                montoTotalEsperado: $montoTotalEsperado,
                estatus: $estatus,
                notas: $notas
            ) {
                paymentSchedule {
                    id
                    fechaVencimiento
                    montoTotalEsperado
                    estatus
                    cliente {
                        id
                        firstName
                        lastName
                    }
                    contrato {
                        id
                        folio
                    }
                }
                success
                error
            }
        }`,
        variables: paymentScheduleData
    });
};

// Mutation: Crear calendario de pagos mensuales
export const createMonthlyPaymentSchedule = (contractId, clientId, startDate, months, montoCapital, montoInteres) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($contractId: ID!, $clienteId: ID!, $startDate: Date!, $months: Int!, $montoCapital: Float!, $montoInteres: Float!) {
            createMonthlyPaymentSchedule(
                contratoId: $contractId,
                clienteId: $clienteId,
                startDate: $startDate,
                months: $months,
                montoCapital: $montoCapital,
                montoInteres: $montoInteres
            ) {
                paymentSchedules {
                    id
                    fechaVencimiento
                    montoTotalEsperado
                    estatus
                }
                success
                error
            }
        }`,
        variables: { contractId, clienteId: clientId, startDate, months, montoCapital, montoInteres }
    });
};

// Mutation: Actualizar pago planificado
export const updatePaymentSchedule = (id, paymentScheduleData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $fechaVencimiento: Date, $montoCapitalEsperado: Float, $montoInteresEsperado: Float, $montoTotalEsperado: Float, $estatus: String, $notas: String) {
            updatePaymentSchedule(
                id: $id,
                fechaVencimiento: $fechaVencimiento,
                montoCapitalEsperado: $montoCapitalEsperado,
                montoInteresEsperado: $montoInteresEsperado,
                montoTotalEsperado: $montoTotalEsperado,
                estatus: $estatus,
                notas: $notas
            ) {
                paymentSchedule {
                    id
                    fechaVencimiento
                    montoTotalEsperado
                    estatus
                }
                success
                error
            }
        }`,
        variables: { id, ...paymentScheduleData }
    });
};

// Mutation: Marcar pago como pagado
export const markPaymentAsPaid = (id, paymentData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $montoInteres: Float!, $montoCapital: Float, $montoInteresMoratorio: Float, $metodoPago: String, $referenciaPago: String, $notas: String, $registradoPorId: ID!, $esPagoParcial: Boolean, $congelarRecargo: Boolean, $monedaPago: String) {
            markPaymentAsPaid(
                id: $id,
                montoInteres: $montoInteres,
                montoCapital: $montoCapital,
                montoInteresMoratorio: $montoInteresMoratorio,
                metodoPago: $metodoPago,
                referenciaPago: $referenciaPago,
                notas: $notas,
                registradoPorId: $registradoPorId,
                esPagoParcial: $esPagoParcial,
                congelarRecargo: $congelarRecargo,
                monedaPago: $monedaPago
            ) {
                payment {
                    id
                    montoTotal
                    montoInteres
                    montoCapital
                    montoInteresMXN
                    montoCapitalMXN
                    montoTotalMXN
                    monedaPago
                    tipoCambioUsado
                    fechaPago
                    estatus
                }
                paymentSchedule {
                    id
                    estatus
                }
                success
                error
            }
        }`,
        variables: { id, ...paymentData }
    });
};

// Mutation: Eliminar pago planificado
export const deletePaymentSchedule = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deletePaymentSchedule(id: $id) {
                success
                error
            }
        }`,
        variables: { id }
    });
};

// ===== PAGOS REALES =====

// Query: Obtener todos los pagos
export const allPayments = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allPayments {
                id
                montoInteres
                montoCapital
                montoTotal
                fechaPago
                estatus
                tipoPago
                metodoPago
                referenciaPago
                notas
                comprobantePago
                cliente {
                    id
                    firstName
                    lastName
                }
                contrato {
                    id
                    folio
                }
            }
        }`
    });
};

// Mutation: Crear pago
export const createPayment = (paymentData) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($contratoId: ID!, $clienteId: ID!, $montoInteres: Float!, $montoCapital: Float!, $deudaPendienteAntes: Float!, $metodoPago: String!, $referenciaPago: String, $notas: String, $registradoPorId: ID!) {
            createPayment(
                contratoId: $contratoId,
                clienteId: $clienteId,
                montoInteres: $montoInteres,
                montoCapital: $montoCapital,
                deudaPendienteAntes: $deudaPendienteAntes,
                metodoPago: $metodoPago,
                referenciaPago: $referenciaPago,
                notas: $notas,
                registradoPorId: $registradoPorId
            ) {
                payment {
                    id
                    montoTotal
                    fechaPago
                    estatus
                }
                success
                error
            }
        }`,
        variables: paymentData
    });
};

// ===== TASAS DE CAMBIO DIARIAS =====

// Query: Obtener todas las tasas de cambio
export const allExchangeRates = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allExchangeRates {
                id
                fecha
                tasaCobro
                tasaVenta
                creadoPor {
                    id
                    email
                }
                fechaCreacion
                fechaModificacion
            }
        }`
    });
};

// Query: Obtener tasa de cambio por fecha
export const exchangeRateByDate = (fecha) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($fecha: Date!) {
            exchangeRateByDate(fecha: $fecha) {
                id
                fecha
                tasaCobro
                tasaVenta
                creadoPor {
                    id
                    email
                }
                fechaCreacion
                fechaModificacion
            }
        }`,
        variables: { fecha }
    });
};

// Query: Obtener tasa de cambio actual
export const currentExchangeRate = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            currentExchangeRate {
                id
                fecha
                tasaCobro
                tasaVenta
                creadoPor {
                    id
                    email
                }
                fechaCreacion
                fechaModificacion
            }
        }`
    });
};

// Query: Obtener tasa de cambio más reciente
export const latestExchangeRate = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            latestExchangeRate {
                id
                fecha
                tasaCobro
                tasaVenta
                creadoPor {
                    id
                    email
                }
                fechaCreacion
                fechaModificacion
            }
        }`
    });
};

// Mutation: Crear/actualizar tasa de cambio
export const createExchangeRate = (exchangeRateData) => {
    const { fecha, tasaCobro, tasaVenta, creadoPorId } = exchangeRateData;
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($fecha: Date!, $tasaCobro: Float!, $tasaVenta: Float!, $creadoPorId: ID!) {
            createExchangeRate(
                fecha: $fecha,
                tasaCobro: $tasaCobro,
                tasaVenta: $tasaVenta,
                creadoPorId: $creadoPorId
            ) {
                exchangeRate {
                    id
                    fecha
                    tasaCobro
                    tasaVenta
                }
                success
                error
            }
        }`,
        variables: { fecha, tasaCobro, tasaVenta, creadoPorId }
    });
};

// ===== RESUMEN DE DEUDA =====

// Query: Obtener resumen de deuda por contrato
export const debtSummaryByContract = (contractId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($contratoId: ID!) {
            debtSummaryByContract(contratoId: $contratoId) {
                montoPrestamoOriginal
                capitalPagado
                capitalPendiente
                interesPagado
                deudaCompletada
                porcentajePagado
            }
        }`,
        variables: { contratoId: contractId }
    });
};

// Crear contrato directamente (no desde cotización)
export const createContractDirect = (data) => {
    // Validar que la fecha de vencimiento esté presente (es obligatoria)
    if (!data.fechaVencimientoPrimeraParcialidad || data.fechaVencimientoPrimeraParcialidad === '') {
        return Promise.reject(new Error('La fecha de vencimiento de la primera parcialidad es obligatoria'));
    }
    
    // Limpiar los datos: convertir valores vacíos a null para campos opcionales
    const cleanedData = { ...data };
    const normalizeId = (value) => {
        if (value === undefined || value === null) return null;
        const normalized = String(value).trim();
        return normalized === '' ? null : normalized;
    };
    if (cleanedData.fechaVencimientoPrimeraParcialidad === '' || cleanedData.fechaVencimientoPrimeraParcialidad === undefined) {
        cleanedData.fechaVencimientoPrimeraParcialidad = null;
    }

    cleanedData.sucursalId = normalizeId(cleanedData.sucursalId);
    cleanedData.ejecutivoId = normalizeId(cleanedData.ejecutivoId);
    cleanedData.vehiculoId = normalizeId(cleanedData.vehiculoId);
    cleanedData.clienteId = normalizeId(cleanedData.clienteId);
    cleanedData.contratoOrigenId = normalizeId(cleanedData.contratoOrigenId);

    if (!cleanedData.sucursalId) {
        return Promise.reject(new Error('La sucursal es obligatoria'));
    }
    if (!cleanedData.ejecutivoId) {
        return Promise.reject(new Error('El ejecutivo es obligatorio'));
    }
    if (!cleanedData.vehiculoId) {
        return Promise.reject(new Error('El vehículo es obligatorio'));
    }
    
    // Limpiar clienteId: si es cadena vacía, undefined o null, excluirlo de las variables
    // Si hay clienteNuevo, también excluir clienteId
    const hasClienteId = !!cleanedData.clienteId && !cleanedData.clienteNuevo;
    if (!hasClienteId) {
        delete cleanedData.clienteId;
    }
    if (!cleanedData.contratoOrigenId) {
        delete cleanedData.contratoOrigenId;
    }
    
    // Asegurar moneda para conversión (USD por defecto). GraphQL espera monedaMonto (camelCase).
    const moneda = cleanedData.monedaMonto ?? cleanedData.moneda_monto ?? 'USD';
    cleanedData.monedaMonto = moneda;
    cleanedData.moneda_monto = moneda;
    
    // Construir la query dinámicamente según qué campos están presentes
    let mutationArgs = `
                fechaFirma: $fechaFirma
                sucursalId: $sucursalId
                ejecutivoId: $ejecutivoId
                vehiculoId: $vehiculoId
                montoPrestamo: $montoPrestamo
                monedaMonto: $monedaMonto`;
    
    if (hasClienteId) {
        mutationArgs += '\n                clienteId: $clienteId';
    }
    
    if (cleanedData.clienteNuevo) {
        mutationArgs += '\n                clienteNuevo: $clienteNuevo';
    }
    
    mutationArgs += `
                montoLetras: $montoLetras
                interesOrdinario: $interesOrdinario
                interesMoratorio: $interesMoratorio
                modalidad: $modalidad
                costoGps: $costoGps
                gpsPagadoPorCliente: $gpsPagadoPorCliente
                fechaVencimientoPrimeraParcialidad: $fechaVencimientoPrimeraParcialidad
                copiaLlave: $copiaLlave
                notasAdicionales: $notasAdicionales
                recordatorios: $recordatorios`;
    
    if (cleanedData.contratoOrigenId) {
        // GraphQL expone el argumento como contratoOrigenId (camelCase)
        mutationArgs += '\n                contratoOrigenId: $contratoOrigenId';
    }
    
    // Construir las variables de la query
    let queryVars = '$fechaFirma: Date!, $sucursalId: ID!, $ejecutivoId: ID!, $vehiculoId: ID!, $montoPrestamo: Float!, $monedaMonto: String';
    if (hasClienteId) {
        queryVars += ', $clienteId: ID';
    }
    if (cleanedData.clienteNuevo) {
        queryVars += ', $clienteNuevo: JSONString';
    }
    queryVars += ', $montoLetras: String, $interesOrdinario: Float, $interesMoratorio: Float, $modalidad: String, $costoGps: Float, $gpsPagadoPorCliente: Boolean, $fechaVencimientoPrimeraParcialidad: Date!, $copiaLlave: String, $notasAdicionales: String, $recordatorios: String';
    
    if (cleanedData.contratoOrigenId) {
        queryVars += ', $contratoOrigenId: ID';
    }
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation(${queryVars}) {
            createContractDirect(${mutationArgs}
            ) {
                success
                contract {
                    id
                    folio
                    cliente { id }
                    vehiculo { id }
                }
                error
            }
        }`,
        variables: cleanedData
    });
};

// Crear documentación del vehículo
// Subir documentación del vehículo al contrato usando FormData
export const createVehicleDocumentation = (contractId, files, copiaLlave = null) => {
    const formData = new FormData();
    
    // Agregar operaciones GraphQL
    formData.append('operations', JSON.stringify({
        query: `mutation($contractId: ID!, $tarjetaCirculacion: Upload, $tarjetaCirculacionDigital: Upload, $ineCliente: Upload, $licenciaCliente: Upload, $documentacionVehiculo1: Upload, $documentacionVehiculo2: Upload, $documentacionVehiculo3: Upload, $documentacionVehiculo4: Upload, $documentacionVehiculo5: Upload, $documentacionVehiculo6: Upload, $documentacionVehiculo7: Upload, $documentacionVehiculo8: Upload, $documentacionVehiculo9: Upload, $documentacionVehiculo10: Upload, $documentacionVehiculo11: Upload, $documentacionVehiculo12: Upload, $copiaLlave: String) {
            createVehicleDocumentation(
                contractId: $contractId,
                tarjetaCirculacion: $tarjetaCirculacion,
                tarjetaCirculacionDigital: $tarjetaCirculacionDigital,
                ineCliente: $ineCliente,
                licenciaCliente: $licenciaCliente,
                documentacionVehiculo1: $documentacionVehiculo1,
                documentacionVehiculo2: $documentacionVehiculo2,
                documentacionVehiculo3: $documentacionVehiculo3,
                documentacionVehiculo4: $documentacionVehiculo4,
                documentacionVehiculo5: $documentacionVehiculo5,
                documentacionVehiculo6: $documentacionVehiculo6,
                documentacionVehiculo7: $documentacionVehiculo7,
                documentacionVehiculo8: $documentacionVehiculo8,
                documentacionVehiculo9: $documentacionVehiculo9,
                documentacionVehiculo10: $documentacionVehiculo10,
                documentacionVehiculo11: $documentacionVehiculo11,
                documentacionVehiculo12: $documentacionVehiculo12,
                copiaLlave: $copiaLlave
            ) {
                success
                documentation {
                    id
                    totalDocumentosVehiculo
                    documentosObligatoriosCompletos
                    documentosOpcionalesCompletos
                }
                error
            }
        }`,
        variables: {
            contractId: contractId,
            tarjetaCirculacion: files.tarjeta_circulacion ? null : null,
            tarjetaCirculacionDigital: files.tarjeta_circulacion_digital ? null : null,
            ineCliente: files.ine_cliente ? null : null,
            licenciaCliente: files.licencia_cliente ? null : null,
            documentacionVehiculo1: files.documentacion_vehiculo_1 ? null : null,
            documentacionVehiculo2: files.documentacion_vehiculo_2 ? null : null,
            documentacionVehiculo3: files.documentacion_vehiculo_3 ? null : null,
            documentacionVehiculo4: files.documentacion_vehiculo_4 ? null : null,
            documentacionVehiculo5: files.documentacion_vehiculo_5 ? null : null,
            documentacionVehiculo6: files.documentacion_vehiculo_6 ? null : null,
            documentacionVehiculo7: files.documentacion_vehiculo_7 ? null : null,
            documentacionVehiculo8: files.documentacion_vehiculo_8 ? null : null,
            documentacionVehiculo9: files.documentacion_vehiculo_9 ? null : null,
            documentacionVehiculo10: files.documentacion_vehiculo_10 ? null : null,
            documentacionVehiculo11: files.documentacion_vehiculo_11 ? null : null,
            documentacionVehiculo12: files.documentacion_vehiculo_12 ? null : null,
            copiaLlave: copiaLlave
        }
    }));
    
    // Mapear archivos
    const map = {};
    let fileIndex = 0;
    
    // Mapeo de nombres snake_case (frontend) a camelCase (GraphQL)
    const fieldMapping = {
        'tarjeta_circulacion': 'tarjetaCirculacion',
        'tarjeta_circulacion_digital': 'tarjetaCirculacionDigital',
        'ine_cliente': 'ineCliente',
        'licencia_cliente': 'licenciaCliente',
        'documentacion_vehiculo_1': 'documentacionVehiculo1',
        'documentacion_vehiculo_2': 'documentacionVehiculo2',
        'documentacion_vehiculo_3': 'documentacionVehiculo3',
        'documentacion_vehiculo_4': 'documentacionVehiculo4',
        'documentacion_vehiculo_5': 'documentacionVehiculo5',
        'documentacion_vehiculo_6': 'documentacionVehiculo6',
        'documentacion_vehiculo_7': 'documentacionVehiculo7',
        'documentacion_vehiculo_8': 'documentacionVehiculo8',
        'documentacion_vehiculo_9': 'documentacionVehiculo9',
        'documentacion_vehiculo_10': 'documentacionVehiculo10',
        'documentacion_vehiculo_11': 'documentacionVehiculo11',
        'documentacion_vehiculo_12': 'documentacionVehiculo12'
    };
    
    Object.keys(fieldMapping).forEach(snakeCaseField => {
        if (files[snakeCaseField]) {
            const fileToProcess = Array.isArray(files[snakeCaseField]) ? files[snakeCaseField][0] : files[snakeCaseField];
            if (fileToProcess instanceof File) {
                const camelCaseField = fieldMapping[snakeCaseField];
                map[fileIndex] = [`variables.${camelCaseField}`];
                formData.append(fileIndex.toString(), fileToProcess);
                fileIndex++;
            }
        }
    });
    
    formData.append('map', JSON.stringify(map));
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// Acciones para obtener marcas, modelos y categorías de vehículos
export const allBrands = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            brands {
                id
                name
            }
        }`
    });
};

export const allModels = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            carModels {
                id
                name
                brand {
                    id
                    name
                }
            }
        }`
    });
};

export const allCategories = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            categories {
                id
                name
            }
        }`
    });
};

// --- FUNCIONES DE SUBIDA DE ARCHIVOS ---

// Subir documentación de cliente usando FormData
export const uploadClientDocumentation = (clientId, files) => {
    const formData = new FormData();
    
    // Agregar operaciones GraphQL
    formData.append('operations', JSON.stringify({
        query: `mutation($clientId: ID!, $ineFoto: Upload, $licenciaFoto: Upload, $comprobanteDomicilio: Upload, $comprobanteIngresos: Upload) {
            uploadClientDocumentation(
                clientId: $clientId,
                ineFoto: $ineFoto,
                licenciaFoto: $licenciaFoto,
                comprobanteDomicilio: $comprobanteDomicilio,
                comprobanteIngresos: $comprobanteIngresos
            ) {
                success
                client {
                    id
                    firstName
                    lastName
                }
                error
            }
        }`,
        variables: {
            clientId: clientId,
            ineFoto: files.ine_foto ? null : null,
            licenciaFoto: files.licencia_foto ? null : null,
            comprobanteDomicilio: files.comprobante_domicilio ? null : null,
            comprobanteIngresos: files.comprobante_ingresos ? null : null
        }
    }));
    
    // Mapear archivos
    const map = {};
    let fileIndex = 0;
    
    const asFile = (v) => (Array.isArray(v) ? v[0] : v);
    if (files.ine_foto && asFile(files.ine_foto) instanceof File) {
        map[fileIndex] = ['variables.ineFoto'];
        formData.append(fileIndex.toString(), asFile(files.ine_foto));
        fileIndex++;
    }
    if (files.licencia_foto && asFile(files.licencia_foto) instanceof File) {
        map[fileIndex] = ['variables.licenciaFoto'];
        formData.append(fileIndex.toString(), asFile(files.licencia_foto));
        fileIndex++;
    }
    if (files.comprobante_domicilio && asFile(files.comprobante_domicilio) instanceof File) {
        map[fileIndex] = ['variables.comprobanteDomicilio'];
        formData.append(fileIndex.toString(), asFile(files.comprobante_domicilio));
        fileIndex++;
    }
    if (files.comprobante_ingresos && asFile(files.comprobante_ingresos) instanceof File) {
        map[fileIndex] = ['variables.comprobanteIngresos'];
        formData.append(fileIndex.toString(), asFile(files.comprobante_ingresos));
        fileIndex++;
    }
    
    formData.append('map', JSON.stringify(map));
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// Subir documentación de vehículo usando FormData
export const uploadCarDocumentation = (carId, files) => {
    const formData = new FormData();
    
    // Agregar operaciones GraphQL
    // Nota: GraphQL convierte automáticamente snake_case a camelCase
    formData.append('operations', JSON.stringify({
        query: `mutation($carId: ID!, $tarjetaCirculacion: Upload, $tarjetaCirculacionDigital: Upload, $licenciaConductor: Upload, $documentacionVehiculo1: Upload, $documentacionVehiculo2: Upload, $documentacionVehiculo3: Upload, $documentacionVehiculo4: Upload, $documentacionVehiculo5: Upload, $documentacionVehiculo6: Upload, $documentacionVehiculo7: Upload, $documentacionVehiculo8: Upload, $documentacionVehiculo9: Upload, $documentacionVehiculo10: Upload, $documentacionVehiculo11: Upload, $documentacionVehiculo12: Upload) {
            uploadCarDocumentation(
                carId: $carId,
                tarjetaCirculacion: $tarjetaCirculacion,
                tarjetaCirculacionDigital: $tarjetaCirculacionDigital,
                licenciaConductor: $licenciaConductor,
                documentacionVehiculo1: $documentacionVehiculo1,
                documentacionVehiculo2: $documentacionVehiculo2,
                documentacionVehiculo3: $documentacionVehiculo3,
                documentacionVehiculo4: $documentacionVehiculo4,
                documentacionVehiculo5: $documentacionVehiculo5,
                documentacionVehiculo6: $documentacionVehiculo6,
                documentacionVehiculo7: $documentacionVehiculo7,
                documentacionVehiculo8: $documentacionVehiculo8,
                documentacionVehiculo9: $documentacionVehiculo9,
                documentacionVehiculo10: $documentacionVehiculo10,
                documentacionVehiculo11: $documentacionVehiculo11,
                documentacionVehiculo12: $documentacionVehiculo12
            ) {
                success
                car {
                    id
                    plate
                    brand {
                        name
                    }
                    carModel {
                        name
                    }
                }
                error
            }
        }`,
        variables: {
            carId: carId,
            tarjetaCirculacion: files.tarjeta_circulacion ? null : null,
            tarjetaCirculacionDigital: files.tarjeta_circulacion_digital ? null : null,
            licenciaConductor: files.licencia_conductor ? null : null,
            documentacionVehiculo1: files.documentacion_vehiculo_1 ? null : null,
            documentacionVehiculo2: files.documentacion_vehiculo_2 ? null : null,
            documentacionVehiculo3: files.documentacion_vehiculo_3 ? null : null,
            documentacionVehiculo4: files.documentacion_vehiculo_4 ? null : null,
            documentacionVehiculo5: files.documentacion_vehiculo_5 ? null : null,
            documentacionVehiculo6: files.documentacion_vehiculo_6 ? null : null,
            documentacionVehiculo7: files.documentacion_vehiculo_7 ? null : null,
            documentacionVehiculo8: files.documentacion_vehiculo_8 ? null : null,
            documentacionVehiculo9: files.documentacion_vehiculo_9 ? null : null,
            documentacionVehiculo10: files.documentacion_vehiculo_10 ? null : null,
            documentacionVehiculo11: files.documentacion_vehiculo_11 ? null : null,
            documentacionVehiculo12: files.documentacion_vehiculo_12 ? null : null
        }
    }));
    
    // Mapear archivos - usar camelCase para las variables de GraphQL
    const map = {};
    let fileIndex = 0;
    
    // Mapeo de nombres snake_case (frontend) a camelCase (GraphQL)
    const fieldMapping = {
        'tarjeta_circulacion': 'tarjetaCirculacion',
        'tarjeta_circulacion_digital': 'tarjetaCirculacionDigital',
        'licencia_conductor': 'licenciaConductor',
        'documentacion_vehiculo_1': 'documentacionVehiculo1',
        'documentacion_vehiculo_2': 'documentacionVehiculo2',
        'documentacion_vehiculo_3': 'documentacionVehiculo3',
        'documentacion_vehiculo_4': 'documentacionVehiculo4',
        'documentacion_vehiculo_5': 'documentacionVehiculo5',
        'documentacion_vehiculo_6': 'documentacionVehiculo6',
        'documentacion_vehiculo_7': 'documentacionVehiculo7',
        'documentacion_vehiculo_8': 'documentacionVehiculo8',
        'documentacion_vehiculo_9': 'documentacionVehiculo9',
        'documentacion_vehiculo_10': 'documentacionVehiculo10',
        'documentacion_vehiculo_11': 'documentacionVehiculo11',
        'documentacion_vehiculo_12': 'documentacionVehiculo12'
    };
    
    const asFile = (v) => (Array.isArray(v) ? v[0] : v);
    Object.keys(fieldMapping).forEach(snakeCaseField => {
        if (files[snakeCaseField]) {
            const f = asFile(files[snakeCaseField]);
            if (!(f instanceof File)) return;
            const camelCaseField = fieldMapping[snakeCaseField];
            map[fileIndex] = [`variables.${camelCaseField}`];
            formData.append(fileIndex.toString(), f);
            fileIndex++;
        }
    });
    
    formData.append('map', JSON.stringify(map));
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// Eliminar un documento del vehículo (mismos nombres de campo que en el modelo, ej. tarjeta_circulacion)
export const deleteCarDocument = (carId, fieldName) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($carId: ID!, $fieldName: String!) {
            deleteCarDocument(
                carId: $carId,
                fieldName: $fieldName
            ) {
                success
                car {
                    id
                    plate
                }
                error
            }
        }`,
        variables: {
            carId,
            fieldName
        }
    });
};

// Subir contrato firmado (PDF) - Usa multipart/form-data con Upload
export const uploadSignedContract = (contractId, file) => {
    const formData = new FormData();
    
    // Agregar operaciones GraphQL
    formData.append('operations', JSON.stringify({
        query: `mutation($contractId: ID!, $file: Upload!) {
            uploadSignedContract(
                contractId: $contractId,
                file: $file
            ) {
                success
                contract {
                    id
                    folio
                    contratoFirmado
                }
                error
                fileUrl
            }
        }`,
        variables: {
            contractId: contractId,
            file: null
        }
    }));
    
    // Mapear archivo
    const map = {
        '0': ['variables.file']
    };
    formData.append('map', JSON.stringify(map));
    formData.append('0', file);
    
    // Obtener token para agregarlo al header
    const token = getToken();
    const headers = {
        'Content-Type': 'multipart/form-data'
    };
    
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
        headers: headers
    });
};

// Subir firma del usuario (imagen para firmar contratos)
export const uploadUserSignature = (userId, file) => {
    const formData = new FormData();
    formData.append('operations', JSON.stringify({
        query: `mutation($userId: ID!, $firma: Upload!) {
            uploadUserSignature(userId: $userId, firma: $firma) {
                success
                error
                firmaUrl
                user { id firstName lastName }
            }
        }`,
        variables: {
            userId: userId,
            firma: null
        }
    }));
    formData.append('map', JSON.stringify({ '0': ['variables.firma'] }));
    formData.append('0', file);
    const token = getToken();
    const headers = { 'Content-Type': 'multipart/form-data' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, { headers });
};

// Eliminar contrato firmado (PDF)
export const deleteSignedContract = (contractId) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($contractId: ID!) {
            deleteSignedContract(contractId: $contractId) {
                success
                contract {
                    id
                    folio
                    contratoFirmado
                }
                error
            }
        }`,
        variables: {
            contractId: contractId
        }
    });
};

// Subir un solo documento del cliente
export const uploadSingleClientDocument = (clientId, fieldName, file) => {
    const formData = new FormData();
    
    // Agregar operaciones GraphQL
    formData.append('operations', JSON.stringify({
        query: `mutation($clientId: ID!, $fieldName: String!, $file: Upload!) {
            uploadSingleClientDocument(
                clientId: $clientId,
                fieldName: $fieldName,
                file: $file
            ) {
                success
                client {
                    id
                    firstName
                    lastName
                    ineFoto
                    licenciaFoto
                    comprobanteDomicilio
                    comprobanteIngresos
                }
                error
                fileUrl
            }
        }`,
        variables: {
            clientId: clientId,
            fieldName: fieldName,
            file: null
        }
    }));
    
    // Mapear archivo
    const map = {
        '0': ['variables.file']
    };
    formData.append('map', JSON.stringify(map));
    formData.append('0', file);
    
    // Obtener token para agregarlo al header
    const token = getToken();
    const headers = {
        'Content-Type': 'multipart/form-data'
    };
    
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
        headers: headers
    });
};

// Eliminar un documento del cliente
export const deleteClientDocument = (clientId, fieldName) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($clientId: ID!, $fieldName: String!) {
            deleteClientDocument(
                clientId: $clientId,
                fieldName: $fieldName
            ) {
                success
                client {
                    id
                    firstName
                    lastName
                    ineFoto
                    licenciaFoto
                    comprobanteDomicilio
                    comprobanteIngresos
                }
                error
            }
        }`,
        variables: {
            clientId: clientId,
            fieldName: fieldName
        }
    });
};

// ===== VEHÍCULOS =====

// Obtener vehículos recuperados
export const getRecoveredVehicles = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            recoveredCars {
                id
                brand {
                    name
                }
                carModel {
                    name
                }
                category {
                    name
                }
                year
                color
                plate
                vin
                mileage
                tipoVehiculo
                createdAt
                updatedAt
            }
        }`
    });
};

// ===== VENTAS DE VEHÍCULOS =====

// Obtener todas las ventas de vehículos
export const allVehicleSales = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            allVehicleSales {
                id
                vehiculo {
                    id
                    brand { name }
                    carModel { name }
                    year
                    plate
                    color
                    vin
                }
                contrato {
                    id
                    folio
                }
                compradorNombre
                compradorApellidos
                compradorTelefono
                compradorEmail
                compradorDireccion
                precioVenta
                fechaVenta
                notas
                comprobanteVenta
                contratoVenta
                registradoPor {
                    id
                    firstName
                    lastName
                    email
                }
                fechaCreacion
                fechaModificacion
                nombreCompletoComprador
            }
        }`
    });
};

// Obtener ventas con filtros
export const vehicleSales = (vehiculoId = null, contratoId = null) => {
    const vehiculoFilter = vehiculoId ? `vehiculoId: "${vehiculoId}"` : '';
    const contratoFilter = contratoId ? `contratoId: "${contratoId}"` : '';
    const filters = [vehiculoFilter, contratoFilter].filter(f => f).join(', ');
    const filterStr = filters ? `(${filters})` : '';
    
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `{
            vehicleSales${filterStr} {
                id
                vehiculo {
                    id
                    brand { name }
                    carModel { name }
                    year
                    plate
                    color
                    vin
                }
                contrato {
                    id
                    folio
                }
                compradorNombre
                compradorApellidos
                compradorTelefono
                compradorEmail
                compradorDireccion
                precioVenta
                fechaVenta
                notas
                comprobanteVenta
                contratoVenta
                registradoPor {
                    id
                    firstName
                    lastName
                    email
                }
                fechaCreacion
                fechaModificacion
                nombreCompletoComprador
            }
        }`
    });
};

// Obtener una venta por ID
export const vehicleSaleById = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($id: ID!) {
            vehicleSaleById(id: $id) {
                id
                vehiculo {
                    id
                    brand { name }
                    carModel { name }
                    year
                    plate
                    color
                    vin
                }
                contrato {
                    id
                    folio
                }
                compradorNombre
                compradorApellidos
                compradorTelefono
                compradorEmail
                compradorDireccion
                precioVenta
                fechaVenta
                notas
                comprobanteVenta
                contratoVenta
                registradoPor {
                    id
                    firstName
                    lastName
                    email
                }
                fechaCreacion
                fechaModificacion
                nombreCompletoComprador
            }
        }`,
        variables: { id }
    });
};

// Crear una nueva venta de vehículo
export const createVehicleSale = (data) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation(
            $vehiculoId: ID!,
            $compradorNombre: String!,
            $precioVenta: Float!,
            $registradoPorId: ID!,
            $contratoId: ID,
            $compradorApellidos: String,
            $compradorTelefono: String,
            $compradorEmail: String,
            $compradorDireccion: String,
            $fechaVenta: Date,
            $notas: String
        ) {
            createVehicleSale(
                vehiculoId: $vehiculoId,
                compradorNombre: $compradorNombre,
                precioVenta: $precioVenta,
                registradoPorId: $registradoPorId,
                contratoId: $contratoId,
                compradorApellidos: $compradorApellidos,
                compradorTelefono: $compradorTelefono,
                compradorEmail: $compradorEmail,
                compradorDireccion: $compradorDireccion,
                fechaVenta: $fechaVenta,
                notas: $notas
            ) {
                vehicleSale {
                    id
                    precioVenta
                    fechaVenta
                    nombreCompletoComprador
                }
                success
                error
            }
        }`,
        variables: data
    });
};

// Actualizar una venta de vehículo
export const updateVehicleSale = (id, data) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation(
            $id: ID!,
            $compradorNombre: String,
            $compradorApellidos: String,
            $compradorTelefono: String,
            $compradorEmail: String,
            $compradorDireccion: String,
            $precioVenta: Float,
            $fechaVenta: Date,
            $notas: String
        ) {
            updateVehicleSale(
                id: $id,
                compradorNombre: $compradorNombre,
                compradorApellidos: $compradorApellidos,
                compradorTelefono: $compradorTelefono,
                compradorEmail: $compradorEmail,
                compradorDireccion: $compradorDireccion,
                precioVenta: $precioVenta,
                fechaVenta: $fechaVenta,
                notas: $notas
            ) {
                vehicleSale {
                    id
                    precioVenta
                    fechaVenta
                    nombreCompletoComprador
                }
                success
                error
            }
        }`,
        variables: { id, ...data }
    });
};

// Eliminar una venta de vehículo
export const deleteVehicleSale = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteVehicleSale(id: $id) {
                success
                error
            }
        }`,
        variables: { id }
    });
};

// ==================== BANNERS ====================

// Obtener todos los banners
export const allBanners = (activeOnly = false) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($activeOnly: Boolean) {
            allBanners(activeOnly: $activeOnly) {
                id
                imagenUrl
                texto
                posicionTexto
                orden
                isActive
                createdAt
                updatedAt
            }
        }`,
        variables: { activeOnly }
    });
};

// Obtener solo banners activos
export const activeBanners = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            activeBanners {
                id
                imagenUrl
                texto
                posicionTexto
                orden
                isActive
            }
        }`
    });
};

// Crear un nuevo banner
export const createBanner = (bannerData) => {
    const { imagen, texto, posicion_texto, orden, is_active } = bannerData;
    
    // Si hay imagen, usar FormData
    if (imagen && imagen instanceof File) {
        const formData = new FormData();
        const operations = {
            query: `mutation($imagen: Upload!, $texto: String, $posicionTexto: String, $orden: Int, $isActive: Boolean) {
                createBanner(
                    imagen: $imagen,
                    texto: $texto,
                    posicionTexto: $posicionTexto,
                    orden: $orden,
                    isActive: $isActive
                ) {
                    banner {
                        id
                        imagenUrl
                        texto
                        posicionTexto
                        orden
                        isActive
                    }
                    success
                    error
                }
            }`,
            variables: {
                imagen: null,
                texto: texto || null,
                posicionTexto: posicion_texto || 'centro',
                orden: orden || 0,
                isActive: is_active !== undefined ? is_active : true
            }
        };
        
        const map = { "0": ["variables.imagen"] };
        formData.append("operations", JSON.stringify(operations));
        formData.append("map", JSON.stringify(map));
        formData.append("0", imagen);
        
        return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } else {
        return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
            query: `mutation($texto: String, $posicionTexto: String, $orden: Int, $isActive: Boolean) {
                createBanner(
                    texto: $texto,
                    posicionTexto: $posicionTexto,
                    orden: $orden,
                    isActive: $isActive
                ) {
                    banner {
                        id
                        imagenUrl
                        texto
                        posicionTexto
                        orden
                        isActive
                    }
                    success
                    error
                }
            }`,
            variables: {
                texto: texto || null,
                posicionTexto: posicion_texto || 'centro',
                orden: orden || 0,
                isActive: is_active !== undefined ? is_active : true
            }
        });
    }
};

// Actualizar un banner
export const updateBanner = (id, bannerData) => {
    const { imagen, texto, posicion_texto, orden, is_active } = bannerData;
    
    // Si hay imagen, usar FormData
    if (imagen && imagen instanceof File) {
        const formData = new FormData();
        const operations = {
            query: `mutation($id: ID!, $imagen: Upload, $texto: String, $posicionTexto: String, $orden: Int, $isActive: Boolean) {
                updateBanner(
                    id: $id,
                    imagen: $imagen,
                    texto: $texto,
                    posicionTexto: $posicionTexto,
                    orden: $orden,
                    isActive: $isActive
                ) {
                    banner {
                        id
                        imagenUrl
                        texto
                        posicionTexto
                        orden
                        isActive
                    }
                    success
                    error
                }
            }`,
            variables: {
                id: id,
                imagen: null,
                texto: texto !== undefined ? texto : null,
                posicionTexto: posicion_texto || null,
                orden: orden !== undefined ? orden : null,
                isActive: is_active !== undefined ? is_active : null
            }
        };
        
        const map = { "0": ["variables.imagen"] };
        formData.append("operations", JSON.stringify(operations));
        formData.append("map", JSON.stringify(map));
        formData.append("0", imagen);
        
        return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    } else {
        return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
            query: `mutation($id: ID!, $texto: String, $posicionTexto: String, $orden: Int, $isActive: Boolean) {
                updateBanner(
                    id: $id,
                    texto: $texto,
                    posicionTexto: $posicionTexto,
                    orden: $orden,
                    isActive: $isActive
                ) {
                    banner {
                        id
                        imagenUrl
                        texto
                        posicionTexto
                        orden
                        isActive
                    }
                    success
                    error
                }
            }`,
            variables: {
                id: id,
                texto: texto !== undefined ? texto : null,
                posicionTexto: posicion_texto || null,
                orden: orden !== undefined ? orden : null,
                isActive: is_active !== undefined ? is_active : null
            }
        });
    }
};

// Eliminar un banner
export const deleteBanner = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteBanner(id: $id) {
                success
                error
            }
        }`,
        variables: { id }
    });
};

// Activar/desactivar un banner
export const toggleBannerActive = (id, isActive) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $isActive: Boolean!) {
            toggleBannerActive(id: $id, isActive: $isActive) {
                banner {
                    id
                    isActive
                }
                success
                error
            }
        }`,
        variables: { id, isActive }
    });
};

// ==================== FAQs (PREGUNTAS FRECUENTES) ====================

// Obtener todas las FAQs
export const allFAQs = (activeOnly = false) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($activeOnly: Boolean) {
            allFaqs(activeOnly: $activeOnly) {
                id
                pregunta
                respuesta
                orden
                isActive
                createdAt
                updatedAt
            }
        }`,
        variables: { activeOnly }
    });
};

// Obtener solo FAQs activas
export const activeFAQs = () => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query {
            activeFaqs {
                id
                pregunta
                respuesta
                orden
                isActive
            }
        }`
    });
};

// ==================== WHATSAPP MESSAGES (MENSAJES DE WHATSAPP) ====================

// Obtener todos los mensajes de WhatsApp registrados (todos los tipos)
export const whatsappMessages = (clienteId = null, contratoId = null, fechaInicio = null, fechaFin = null, notificationType = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($clienteId: ID, $contratoId: ID, $fechaInicio: String, $fechaFin: String, $notificationType: String) {
            whatsappMessages(
                clienteId: $clienteId,
                contratoId: $contratoId,
                fechaInicio: $fechaInicio,
                fechaFin: $fechaFin,
                notificationType: $notificationType
            ) {
                id
                fechaEnvio
                nombreCliente
                folioContrato
                fechaVencimientoPago
                phoneNumber
                status
                messageId
                notificationType
                content
                errorMessage
                cliente {
                    id
                    firstName
                    lastName
                }
                contrato {
                    id
                    folio
                }
                pagoPlanificado {
                    id
                    fechaVencimiento
                    montoTotalEsperado
                }
            }
        }`,
        variables: { clienteId, contratoId, fechaInicio, fechaFin, notificationType }
    });
};

// Obtener mensajes de notificación de pagos (solo tipo PAYMENT_REMINDER)
export const paymentNotificationMessages = (clienteId = null, contratoId = null, fechaInicio = null, fechaFin = null) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `query($clienteId: ID, $contratoId: ID, $fechaInicio: String, $fechaFin: String) {
            paymentNotificationMessages(
                clienteId: $clienteId,
                contratoId: $contratoId,
                fechaInicio: $fechaInicio,
                fechaFin: $fechaFin
            ) {
                id
                fechaEnvio
                nombreCliente
                folioContrato
                fechaVencimientoPago
                phoneNumber
                status
                notificationType
                content
                cliente {
                    id
                    firstName
                    lastName
                }
                contrato {
                    id
                    folio
                }
                pagoPlanificado {
                    id
                    fechaVencimiento
                    montoTotalEsperado
                }
            }
        }`,
        variables: { clienteId, contratoId, fechaInicio, fechaFin }
    });
};

// Crear una nueva FAQ
export const createFAQ = (faqData) => {
    const { pregunta, respuesta, orden = 0, is_active = true } = faqData;
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($pregunta: String!, $respuesta: String!, $orden: Int, $isActive: Boolean) {
            createFaq(
                pregunta: $pregunta,
                respuesta: $respuesta,
                orden: $orden,
                isActive: $isActive
            ) {
                faq {
                    id
                    pregunta
                    respuesta
                    orden
                    isActive
                    createdAt
                    updatedAt
                }
                success
                error
            }
        }`,
        variables: {
            pregunta,
            respuesta,
            orden,
            isActive: is_active
        }
    });
};

// Actualizar una FAQ
export const updateFAQ = (id, faqData) => {
    const { pregunta, respuesta, orden, is_active } = faqData;
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $pregunta: String, $respuesta: String, $orden: Int, $isActive: Boolean) {
            updateFaq(
                id: $id,
                pregunta: $pregunta,
                respuesta: $respuesta,
                orden: $orden,
                isActive: $isActive
            ) {
                faq {
                    id
                    pregunta
                    respuesta
                    orden
                    isActive
                    createdAt
                    updatedAt
                }
                success
                error
            }
        }`,
        variables: {
            id,
            pregunta: pregunta !== undefined ? pregunta : null,
            respuesta: respuesta !== undefined ? respuesta : null,
            orden: orden !== undefined ? orden : null,
            isActive: is_active !== undefined ? is_active : null
        }
    });
};

// Eliminar una FAQ
export const deleteFAQ = (id) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!) {
            deleteFaq(id: $id) {
                success
                error
            }
        }`,
        variables: { id }
    });
};

// Activar/desactivar una FAQ
export const toggleFAQActive = (id, isActive) => {
    return axios.post(process.env.VUE_APP_URL_SERVICES_GRAPHQL, {
        query: `mutation($id: ID!, $isActive: Boolean!) {
            toggleFaqActive(id: $id, isActive: $isActive) {
                faq {
                    id
                    isActive
                }
                success
                error
            }
        }`,
        variables: { id, isActive }
    });
};